// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.mat-ripple {
  overflow: hidden;
  position: relative;
}
.mat-ripple:not(:empty) {
  transform: translateZ(0);
}

.mat-ripple.mat-ripple-unbounded {
  overflow: visible;
}

.mat-ripple-element {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  transition: opacity, transform 0ms cubic-bezier(0, 0, 0.2, 1);
  transform: scale3d(0, 0, 0);
}
.cdk-high-contrast-active .mat-ripple-element {
  display: none;
}

.cdk-visually-hidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
  outline: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  left: 0;
}
[dir=rtl] .cdk-visually-hidden {
  left: auto;
  right: 0;
}

.cdk-overlay-container, .cdk-global-overlay-wrapper {
  pointer-events: none;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.cdk-overlay-container {
  position: fixed;
  z-index: 1000;
}
.cdk-overlay-container:empty {
  display: none;
}

.cdk-global-overlay-wrapper {
  display: flex;
  position: absolute;
  z-index: 1000;
}

.cdk-overlay-pane {
  position: absolute;
  pointer-events: auto;
  box-sizing: border-box;
  z-index: 1000;
  display: flex;
  max-width: 100%;
  max-height: 100%;
}

.cdk-overlay-backdrop {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  pointer-events: auto;
  -webkit-tap-highlight-color: transparent;
  transition: opacity 400ms cubic-bezier(0.25, 0.8, 0.25, 1);
  opacity: 0;
}
.cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
  opacity: 1;
}
.cdk-high-contrast-active .cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
  opacity: 0.6;
}

.cdk-overlay-dark-backdrop {
  background: rgba(0, 0, 0, 0.32);
}

.cdk-overlay-transparent-backdrop {
  transition: visibility 1ms linear, opacity 1ms linear;
  visibility: hidden;
  opacity: 1;
}
.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {
  opacity: 0;
  visibility: visible;
}

.cdk-overlay-backdrop-noop-animation {
  transition: none;
}

.cdk-overlay-connected-position-bounding-box {
  position: absolute;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  min-width: 1px;
  min-height: 1px;
}

.cdk-global-scrollblock {
  position: fixed;
  width: 100%;
  overflow-y: scroll;
}

textarea.cdk-textarea-autosize {
  resize: none;
}

textarea.cdk-textarea-autosize-measuring {
  padding: 2px 0 !important;
  box-sizing: content-box !important;
  height: auto !important;
  overflow: hidden !important;
}

textarea.cdk-textarea-autosize-measuring-firefox {
  padding: 2px 0 !important;
  box-sizing: content-box !important;
  height: 0 !important;
}

@keyframes cdk-text-field-autofill-start { /*!*/ }
@keyframes cdk-text-field-autofill-end { /*!*/ }
.cdk-text-field-autofill-monitored:-webkit-autofill {
  animation: cdk-text-field-autofill-start 0s 1ms;
}

.cdk-text-field-autofill-monitored:not(:-webkit-autofill) {
  animation: cdk-text-field-autofill-end 0s 1ms;
}

.mat-focus-indicator {
  position: relative;
}
.mat-focus-indicator::before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  display: var(--mat-focus-indicator-display, none);
  border: var(--mat-focus-indicator-border-width, 3px) var(--mat-focus-indicator-border-style, solid) var(--mat-focus-indicator-border-color, transparent);
  border-radius: var(--mat-focus-indicator-border-radius, 4px);
}
.mat-focus-indicator:focus::before {
  content: "";
}

.cdk-high-contrast-active {
  --mat-focus-indicator-display: block;
}

.mat-mdc-focus-indicator {
  position: relative;
}
.mat-mdc-focus-indicator::before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  display: var(--mat-mdc-focus-indicator-display, none);
  border: var(--mat-mdc-focus-indicator-border-width, 3px) var(--mat-mdc-focus-indicator-border-style, solid) var(--mat-mdc-focus-indicator-border-color, transparent);
  border-radius: var(--mat-mdc-focus-indicator-border-radius, 4px);
}
.mat-mdc-focus-indicator:focus::before {
  content: "";
}

.cdk-high-contrast-active {
  --mat-mdc-focus-indicator-display: block;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
body {
  font-family: "Barlow", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
}

h1 {
  font-size: 64px;
  line-height: 78px;
}

h2 {
  font-size: 56px;
  line-height: 68px;
}

h3 {
  font-size: 48px;
  line-height: 58px;
}

h4 {
  font-size: 40px;
  line-height: 48px;
}

h5 {
  font-size: 32px;
  line-height: 39px;
}

h6 {
  font-size: 24px;
  line-height: 29px;
}

a {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  color: rgb(174, 15, 10);
  cursor: pointer;
  text-decoration: underline;
}

caption {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
}

th {
  font-weight: 700;
  cursor: pointer;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
.p-0 {
  padding: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.pr-0 {
  padding-right: 0px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pl-0 {
  padding-left: 0px;
}

.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}

.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}

.m-0 {
  margin: 0px;
}

.mt-0 {
  margin-top: 0px;
}

.mr-0 {
  margin-right: 0px;
}

.mb-0 {
  margin-bottom: 0px;
}

.ml-0 {
  margin-left: 0px;
}

.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}

.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.p-1 {
  padding: 8px;
}

.pt-1 {
  padding-top: 8px;
}

.pr-1 {
  padding-right: 8px;
}

.pb-1 {
  padding-bottom: 8px;
}

.pl-1 {
  padding-left: 8px;
}

.px-1 {
  padding-left: 8px;
  padding-right: 8px;
}

.py-1 {
  padding-top: 8px;
  padding-bottom: 8px;
}

.m-1 {
  margin: 8px;
}

.mt-1 {
  margin-top: 8px;
}

.mr-1 {
  margin-right: 8px;
}

.mb-1 {
  margin-bottom: 8px;
}

.ml-1 {
  margin-left: 8px;
}

.mx-1 {
  margin-left: 8px;
  margin-right: 8px;
}

.my-1 {
  margin-top: 8px;
  margin-bottom: 8px;
}

.p-2 {
  padding: 16px;
}

.pt-2 {
  padding-top: 16px;
}

.pr-2 {
  padding-right: 16px;
}

.pb-2 {
  padding-bottom: 16px;
}

.pl-2 {
  padding-left: 16px;
}

.px-2 {
  padding-left: 16px;
  padding-right: 16px;
}

.py-2 {
  padding-top: 16px;
  padding-bottom: 16px;
}

.m-2 {
  margin: 16px;
}

.mt-2 {
  margin-top: 16px;
}

.mr-2 {
  margin-right: 16px;
}

.mb-2 {
  margin-bottom: 16px;
}

.ml-2 {
  margin-left: 16px;
}

.mx-2 {
  margin-left: 16px;
  margin-right: 16px;
}

.my-2 {
  margin-top: 16px;
  margin-bottom: 16px;
}

.p-3 {
  padding: 24px;
}

.pt-3 {
  padding-top: 24px;
}

.pr-3 {
  padding-right: 24px;
}

.pb-3 {
  padding-bottom: 24px;
}

.pl-3 {
  padding-left: 24px;
}

.px-3 {
  padding-left: 24px;
  padding-right: 24px;
}

.py-3 {
  padding-top: 24px;
  padding-bottom: 24px;
}

.m-3 {
  margin: 24px;
}

.mt-3 {
  margin-top: 24px;
}

.mr-3 {
  margin-right: 24px;
}

.mb-3 {
  margin-bottom: 24px;
}

.ml-3 {
  margin-left: 24px;
}

.mx-3 {
  margin-left: 24px;
  margin-right: 24px;
}

.my-3 {
  margin-top: 24px;
  margin-bottom: 24px;
}

.p-4 {
  padding: 32px;
}

.pt-4 {
  padding-top: 32px;
}

.pr-4 {
  padding-right: 32px;
}

.pb-4 {
  padding-bottom: 32px;
}

.pl-4 {
  padding-left: 32px;
}

.px-4 {
  padding-left: 32px;
  padding-right: 32px;
}

.py-4 {
  padding-top: 32px;
  padding-bottom: 32px;
}

.m-4 {
  margin: 32px;
}

.mt-4 {
  margin-top: 32px;
}

.mr-4 {
  margin-right: 32px;
}

.mb-4 {
  margin-bottom: 32px;
}

.ml-4 {
  margin-left: 32px;
}

.mx-4 {
  margin-left: 32px;
  margin-right: 32px;
}

.my-4 {
  margin-top: 32px;
  margin-bottom: 32px;
}

.p-5 {
  padding: 40px;
}

.pt-5 {
  padding-top: 40px;
}

.pr-5 {
  padding-right: 40px;
}

.pb-5 {
  padding-bottom: 40px;
}

.pl-5 {
  padding-left: 40px;
}

.px-5 {
  padding-left: 40px;
  padding-right: 40px;
}

.py-5 {
  padding-top: 40px;
  padding-bottom: 40px;
}

.m-5 {
  margin: 40px;
}

.mt-5 {
  margin-top: 40px;
}

.mr-5 {
  margin-right: 40px;
}

.mb-5 {
  margin-bottom: 40px;
}

.ml-5 {
  margin-left: 40px;
}

.mx-5 {
  margin-left: 40px;
  margin-right: 40px;
}

.my-5 {
  margin-top: 40px;
  margin-bottom: 40px;
}

.p-6 {
  padding: 48px;
}

.pt-6 {
  padding-top: 48px;
}

.pr-6 {
  padding-right: 48px;
}

.pb-6 {
  padding-bottom: 48px;
}

.pl-6 {
  padding-left: 48px;
}

.px-6 {
  padding-left: 48px;
  padding-right: 48px;
}

.py-6 {
  padding-top: 48px;
  padding-bottom: 48px;
}

.m-6 {
  margin: 48px;
}

.mt-6 {
  margin-top: 48px;
}

.mr-6 {
  margin-right: 48px;
}

.mb-6 {
  margin-bottom: 48px;
}

.ml-6 {
  margin-left: 48px;
}

.mx-6 {
  margin-left: 48px;
  margin-right: 48px;
}

.my-6 {
  margin-top: 48px;
  margin-bottom: 48px;
}

.p-7 {
  padding: 56px;
}

.pt-7 {
  padding-top: 56px;
}

.pr-7 {
  padding-right: 56px;
}

.pb-7 {
  padding-bottom: 56px;
}

.pl-7 {
  padding-left: 56px;
}

.px-7 {
  padding-left: 56px;
  padding-right: 56px;
}

.py-7 {
  padding-top: 56px;
  padding-bottom: 56px;
}

.m-7 {
  margin: 56px;
}

.mt-7 {
  margin-top: 56px;
}

.mr-7 {
  margin-right: 56px;
}

.mb-7 {
  margin-bottom: 56px;
}

.ml-7 {
  margin-left: 56px;
}

.mx-7 {
  margin-left: 56px;
  margin-right: 56px;
}

.my-7 {
  margin-top: 56px;
  margin-bottom: 56px;
}

.p-8 {
  padding: 64px;
}

.pt-8 {
  padding-top: 64px;
}

.pr-8 {
  padding-right: 64px;
}

.pb-8 {
  padding-bottom: 64px;
}

.pl-8 {
  padding-left: 64px;
}

.px-8 {
  padding-left: 64px;
  padding-right: 64px;
}

.py-8 {
  padding-top: 64px;
  padding-bottom: 64px;
}

.m-8 {
  margin: 64px;
}

.mt-8 {
  margin-top: 64px;
}

.mr-8 {
  margin-right: 64px;
}

.mb-8 {
  margin-bottom: 64px;
}

.ml-8 {
  margin-left: 64px;
}

.mx-8 {
  margin-left: 64px;
  margin-right: 64px;
}

.my-8 {
  margin-top: 64px;
  margin-bottom: 64px;
}

.p-9 {
  padding: 72px;
}

.pt-9 {
  padding-top: 72px;
}

.pr-9 {
  padding-right: 72px;
}

.pb-9 {
  padding-bottom: 72px;
}

.pl-9 {
  padding-left: 72px;
}

.px-9 {
  padding-left: 72px;
  padding-right: 72px;
}

.py-9 {
  padding-top: 72px;
  padding-bottom: 72px;
}

.m-9 {
  margin: 72px;
}

.mt-9 {
  margin-top: 72px;
}

.mr-9 {
  margin-right: 72px;
}

.mb-9 {
  margin-bottom: 72px;
}

.ml-9 {
  margin-left: 72px;
}

.mx-9 {
  margin-left: 72px;
  margin-right: 72px;
}

.my-9 {
  margin-top: 72px;
  margin-bottom: 72px;
}

.p-10 {
  padding: 80px;
}

.pt-10 {
  padding-top: 80px;
}

.pr-10 {
  padding-right: 80px;
}

.pb-10 {
  padding-bottom: 80px;
}

.pl-10 {
  padding-left: 80px;
}

.px-10 {
  padding-left: 80px;
  padding-right: 80px;
}

.py-10 {
  padding-top: 80px;
  padding-bottom: 80px;
}

.m-10 {
  margin: 80px;
}

.mt-10 {
  margin-top: 80px;
}

.mr-10 {
  margin-right: 80px;
}

.mb-10 {
  margin-bottom: 80px;
}

.ml-10 {
  margin-left: 80px;
}

.mx-10 {
  margin-left: 80px;
  margin-right: 80px;
}

.my-10 {
  margin-top: 80px;
  margin-bottom: 80px;
}

html {
  --mdc-outlined-text-field-focus-outline-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mdc-outlined-text-field-focus-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-option-selected-state-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-datepicker-toggle-active-state-icon-color: rgba(
    174,
    15,
    10,
    1
  ) !important;
  --mdc-filled-text-field-focus-active-indicator-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-sidenav-content-background-color: white !important;
}

/* You can add global styles to this file, and also import other style files */
/* Angular 15 adds grey background on mat form components */
/* below removes that background color */
/* Manipulate initial background color*/
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

/*Manipulate background color on hover and focus*/
.mat-mdc-form-field-focus-overlay {
  background-color: transparent !important;
}

.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {
  width: 0px;
  padding-left: 6px;
  padding-right: 6px;
}
.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted span {
  display: none;
}

/* Pagination menu */
.g-bubble-container {
  display: flex;
  gap: 4px;
  margin-left: 8px;
}

.g-bubble {
  background-color: rgb(245, 246, 249);
  border-radius: 4px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(34, 36, 40) !important;
  font-size: 1rem;
  cursor: pointer;
  transition: 0.3s;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-align: center;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}

.g-bubble:hover {
  background-color: rgb(189, 188, 188);
  color: rgb(245, 246, 249);
}

.g-bubble__active {
  background-color: rgb(227, 6, 19);
  color: rgb(227, 227, 227) !important;
  box-shadow: 0px 5px 14px 0px rgba(0, 0, 0, 0.12), 0px 9px 10px 0px rgba(0, 0, 0, 0.14), 0px 5px 5px 0px rgba(0, 0, 0, 0.2);
}

mat-paginator {
  background: transparent !important;
}

.mat-mdc-paginator-range-actions {
  margin-right: 12px !important;
}

.mat-mdc-paginator-container {
  justify-content: center !important;
}

.mat-mdc-paginator-navigation-next,
.mat-mdc-paginator-navigation-previous {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: rgb(34, 36, 40) !important;
  padding: 0 !important;
  border-radius: 4px !important;
  width: 34px !important;
  height: 34px !important;
  background-color: rgb(245, 246, 249) !important;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}

/* End of pagination menu */
body {
  margin: 0;
}

.snackbar {
  width: 50vw;
  margin: 10px 0px !important;
}
.snackbar .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
}
.snackbar .mdc-snackbar__label {
  color: black !important;
}
.snackbar .mat-icon {
  margin-right: 12px;
}

.snackbar-custom {
  width: 50vw;
  margin-top: 75px !important;
}

.snacbar-warning {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-warning .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid #e0ac08;
}
.snacbar-warning .mdc-snackbar__label {
  color: black !important;
}
.snacbar-warning .mat-icon {
  margin-right: 12px;
}

.snacbar-sucess {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-sucess .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid green;
}
.snacbar-sucess .mdc-snackbar__label {
  color: black !important;
}
.snacbar-sucess .mat-icon {
  margin-right: 12px;
}

.snacbar-error {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-error .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid red;
}
.snacbar-error .mdc-snackbar__label {
  color: black !important;
}
.snacbar-error .mat-icon {
  margin-right: 12px;
}

.flex {
  display: flex;
}

.mat-mdc-menu-panel {
  overflow: hidden !important;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .menu-header {
  font-size: 12px;
  padding: 1rem;
  padding-bottom: 0.25rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item {
  margin-left: 1rem;
  padding-left: 0;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:first-of-type {
  margin-top: 0.75rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:not(:last-child) {
  border-bottom: 1px solid rgb(189, 188, 188);
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 3000;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sort-icon-container {
  display: inline-flex;
  align-items: center;
}
.sort-icon-container mat-icon {
  height: 1rem;
  width: 1rem;
}

@media (max-width: 767px) {
  app-edit-contract .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40% !important;
    height: 45px;
  }
}

.btn-primary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(174, 15, 10);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40%;
    height: 45px;
  }
}
.btn-primary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
  background: white;
  color: rgb(174, 15, 10);
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: 2px solid rgb(174, 15, 10);
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}
.btn-secondary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(189, 188, 188);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}

/* 
  IONIC components
*/
ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-item.no-padding-full {
  --padding-end: 0;
  --padding-start: 0;
  --inner-padding-end: 0;
  --inner-padding-start: 0;
}

ion-checkbox {
  --checkbox-background-checked: rgba(174, 15, 10, 1);
  --border-color-checked: rgba(174, 15, 10, 1);
}

ion-input.custom-input {
  --border-color: rgba(135, 135, 135, 1);
  --padding-top: 5px;
  --highlight-color: rgba(135, 135, 135, 1);
}

ion-input.custom-input-user {
  --border-color: #EFEFEF;
  --padding-top: 5px;
  --highlight-color: rgba(135, 135, 135, 1);
}

ion-input.width-full {
  --border-color: #EFEFEF !important;
  --padding-top: 5px;
  --highlight-color: rgb(37, 19, 19);
}

.filter-panel {
  max-width: 100vw !important;
}

.date-select-modal-filter .mdc-text-field {
  height: 35px;
}
.date-select-modal-filter .mat-mdc-form-field-infix {
  height: 35px;
  min-height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.date-select-modal-filter .select-year .mat-mdc-text-field-wrapper {
  background-color: #f4f4f4;
  border: 1px solid rgb(189, 188, 188);
}
.date-select-modal-filter .mdc-notched-outline__leading {
  border: none !important;
}
.date-select-modal-filter .mdc-notched-outline__notch {
  border: none !important;
}
.date-select-modal-filter .mdc-notched-outline__trailing {
  border: none !important;
}

@media (min-width: 1025px) {
  .filter-panel {
    max-height: 33rem !important;
    min-width: 60vw;
  }
  .anotation-panel {
    max-width: 30rem !important;
    max-height: 30rem !important;
    min-width: 50vw;
  }
  .historic-panel {
    min-width: 49.5rem;
    min-height: 35.625rem;
    min-width: 50vw;
  }
  .segments-panel {
    width: 72vw;
    min-width: 760px;
    max-width: 1100px !important;
    max-height: 90vh !important;
  }
  .new-highway-modal-panel {
    min-width: 49.5rem;
    min-height: 23.625rem;
    min-width: 50vw;
  }
}
@media (max-width: 1024px) {
  .btn-actions {
    margin-right: 15px;
  }
  .filter-panel {
    min-height: 30rem;
    max-width: 100vw !important;
    min-width: 90vw;
  }
  .historic-panel {
    max-width: 49.5rem;
    min-width: 90vw !important;
  }
  .segments-panel {
    max-width: 90vw !important;
    min-width: 90vw !important;
    max-height: 90vh !important;
  }
  .new-highway-modal-panel {
    max-width: 49.5rem;
    min-width: 90vw !important;
  }
}
@media (max-width: 1024px) {
  .anotation-panel {
    width: 90%;
  }
}
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

@media (max-width: 1024px) {
  .mat-mdc-form-field-label {
    font-size: 0.8rem;
    /* Tamanho de fonte para dispositivos móveis */
  }
}
.button_cad {
  background-color: rgb(174, 15, 10);
  padding: 0.5rem 2rem;
  border-radius: 0.5rem;
  color: #fff;
  font-style: none;
  text-decoration: none;
}
.button_cad mat-icon {
  color: #fff !important;
}

::ng-deep.mat-mdc-card-header-text {
  display: none !important;
}

.input-error {
  border: 1px solid red; /* Ajuste o estilo conforme necessário */
}

.card-mobile {
  min-height: 10rem;
  margin: 1rem auto;
  border: 1px solid #cdcdcd;
}
.card-mobile .mat-mdc-card-header {
  width: 90%;
  display: flex;
  margin: auto;
  justify-content: space-between;
  padding: 0rem;
}
.card-mobile .mat-mdc-card-header p {
  font-weight: bolder;
  font-size: 1.2rem;
  text-transform: uppercase;
}
.card-mobile .mat-mdc-card-header span,
.card-mobile .mat-mdc-card-header .subtitle {
  font-size: 1rem;
  font-weight: normal;
  color: #cdcdcd;
}
@media (max-width: 1024px) {
  .card-mobile .mat-mdc-card-header {
    width: 100%;
    margin: 0 16px;
  }
}
.card-mobile .mat-mdc-card-footer {
  margin: 1rem 0rem;
  border-top: 1px solid black;
  display: flex;
  align-items: center;
}
.card-mobile .mat-mdc-card-footer button {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.card-mobile .extension {
  font-weight: bold;
  color: rgb(174, 15, 10);
}
@media (max-width: 1024px) {
  .card-mobile .formatAnotation {
    padding: 0 16px;
  }
}
.card-mobile .content-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-mobile .content-status {
  width: 40%;
  align-items: center;
  display: flex;
  flex-direction: column;
}
.card-mobile .content-status p {
  font-weight: bold;
}

.card-mobile-empty {
  border: 1px solid #cdcdcd;
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-button.more-filters-btn {
  --background: rgba(174, 15, 10, 1);
  --color: white;
  --border-radius: 10px;
  width: 100%;
  max-width: 15rem;
  text-transform: capitalize;
  font-size: 0.9rem;
  height: 100%;
  font-weight: 600;
  letter-spacing: 0.08em;
}

ion-item.fast-filters {
  padding: 0.25rem 0rem;
}

ion-chip.fast-filter-active-primary {
  background-color: rgb(40, 186, 98);
  color: white;
}

ion-chip.fast-filter-active-secondary {
  background-color: rgb(235, 68, 90);
  color: white;
}

ion-chip.fast-filter-active-primary-contract {
  color: #AE0F0A;
  border: 1px solid #AE0F0A;
  background: #E4ADB5;
}

ion-chip.fast-filter-active-secondary-contract {
  color: #AE0F0A;
  border: 1px solid #AE0F0A;
  background: #E4ADB5;
}

.more-filters-btn-row {
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.more-filters-btn-row button {
  margin: 5px;
}
@media (max-width: 767px) {
  .more-filters-btn-row button {
    margin: 5px 0;
  }
}

.status-container {
  display: flex;
  align-items: center;
}
.status-container .mat-icon {
  width: 1rem;
}
.status-container .status-icon {
  font-size: 8px;
  align-content: center;
  text-align: center;
}
.status-container .active {
  color: rgb(40, 186, 98);
}
.status-container .inactive {
  color: rgb(235, 68, 90);
}

ion-textarea,
ion-input {
  --border-color: rgba(87, 87, 86, 1);
  --padding-top: 5px !important;
  --highlight-color: rgba(135, 135, 135, 1);
  --highlight-color-focused: rgba(135, 135, 135, 1) !important;
  --highlight-color-valid: rgba(135, 135, 135, 1) !important;
  --highlight-color-invalid: rgba(174, 15, 10, 1) !important;
}

ion-alert.custom-alert {
  --backdrop-opacity: 0.7;
}

ion-list.filtered-list {
  display: flex;
  flex-wrap: wrap;
}
ion-list.filtered-list span {
  padding: 0.75rem 0;
  margin: 0 0.75rem;
  border-bottom: 1px solid rgb(189, 188, 188);
  width: 100%;
}

ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-toast.snackbar-toast {
  --box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
  --width: fit-content;
  --border-radius: 0.75rem;
  --white-space: pre-line;
}

ion-toast.snackbar-toast::part(container) {
  background: #fff;
  color: rgb(34, 36, 40);
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 0.75rem;
}

ion-toast.snackbar-toast.toast-success::part(container) {
  border: 1px solid rgb(45, 211, 111);
}
ion-toast.snackbar-toast.toast-success::part(icon) {
  color: rgb(45, 211, 111);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-error::part(container) {
  border: 1px solid rgb(235, 68, 90);
}
ion-toast.snackbar-toast.toast-error::part(icon) {
  color: rgb(235, 68, 90);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-right {
  --start: right;
  --box-shadow: none;
  --background: none;
}
ion-toast.snackbar-toast.toast-right::part(container) {
  transform: translateY(72px) !important;
  box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
}

::ng-deep.mat-tab-label {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: red !important;
  font-weight: 700;
}

/* Styles for the active tab label */
::ng-deep.mat-tab-label.mat-tab-label-active {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: red !important;
  font-weight: 700;
}

::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline {
  border-color: #2b2b2b;
}

::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #2b2b2b;
}

.mat-mdc-paginator-navigation-next, .mat-mdc-paginator-navigation-previous {
  box-shadow: none !important;
}

.g-bubble {
  box-shadow: none !important;
}

app-modal-historic-segment {
  display: block;
  width: 100%;
  height: 45em;
}

.column-flex {
  display: flex;
  flex-flow: column;
}

.master-icon {
  background-color: rgb(255, 202, 34);
  color: rgb(34, 36, 40);
  border-radius: 10px;
  align-self: flex-start;
  font-size: 10px;
  padding: 0px 9px;
  margin: 6px 0;
  line-height: 17px;
  font-weight: 600;
}
.master-icon.center-horizontal {
  place-self: center;
}

ion-popover {
  --min-width: 375px;
  --max-width: 500px;
}

.custom-tooltip-menu {
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.custom-tooltip-menu .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {
  background: none;
}
.custom-tooltip-menu .mdc-evolution-chip__text-label {
  color: #c00;
}

.custom-tooltip-menu .filter-title {
  font-size: 12px;
  font-weight: bold;
  color: #333;
  display: block;
  margin-bottom: 4px;
  border-bottom: 1px solid grey;
}

.custom-tooltip-menu .tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.custom-tooltip-menu mat-chip {
  border: 1px solid #c00;
  height: 20px;
}

.custom-tooltip-menu mat-chip mat-icon {
  color: #c00 !important;
  cursor: pointer;
  font-size: 14px !important;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0px !important;
}

.custom-tooltip-menu mat-chip .mdc-evolution-chip__text-label {
  color: #c00 !important;
  cursor: pointer;
  font-size: 12px !important;
  opacity: 1;
}

::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline {
  border: 1px solid #c00 !important;
}

::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #c00 !important;
}

ion-toggle {
  --handle-background-checked: rgba(174, 15, 10, 1);
  --track-background-checked: rgba(174, 15, 10, 0.38);
}

app-list-contracts thead {
  background: #F4F4F4 !important;
}

app-table-default thead {
  background: #F4F4F4 !important;
}

.mat-expansion-panel-body {
  padding: 0px !important;
}

.mat-mdc-paginator-range-actions {
  overflow-wrap: anywhere !important;
  flex-grow: 1;
  justify-content: center !important;
  position: relative !important;
}

.mat-mdc-paginator-container:has(.mat-mdc-paginator-page-size) .mat-mdc-paginator-range-actions .mat-mdc-paginator-range-label {
  position: absolute !important;
  left: 0 !important;
}

.mat-mdc-tab {
  background-color: #F4F4F4 !important;
}

.mdc-tab--active {
  background-color: white !important;
}

@media (max-width: 1025px) {
  #paginator {
    width: 100%;
  }
}

ion-icon.search-icon-absolute {
  position: absolute;
  left: 16px;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 3;
}

ion-input.search-input label.input-wrapper {
  --padding-start: 55px;
}
.mat-mdc-icon-button[disabled] {
  cursor: default;
  pointer-events: auto;
  opacity: 0.38;
}

.mat-mdc-unelevated-button[disabled] {
  cursor: default;
  pointer-events: auto;
  opacity: 0.38;
}

.item-inner {
  padding-right: 0 !important;
}

@media (max-width: 496px) {
  .mat-mdc-paginator-page-size-label {
    display: none !important;
  }
}

.comentarios .mdc-text-field--outlined {
  --mdc-outlined-text-field-outline-width: 1px;
  --mdc-outlined-text-field-outline-color: #EFEFEF; /* Borda normal */
  --mdc-outlined-text-field-focus-outline-color: #EFEFEF; /* Borda ao focar */
  --mdc-outlined-text-field-container-shape: 4px;
}

.g-0 {
  gap: 0 !important;
}

.g-1 {
  gap: 0.25rem !important;
}

.g-2 {
  gap: 0.5rem !important;
}

.g-3 {
  gap: 1rem !important;
}

.g-4 {
  gap: 1.5rem !important;
}

.g-5 {
  gap: 3rem !important;
}

.gx-0 {
  column-gap: 0 !important;
}

.gx-1 {
  column-gap: 0.25rem !important;
}

.gx-2 {
  column-gap: 0.5rem !important;
}

.gx-3 {
  column-gap: 1rem !important;
}

.gx-4 {
  column-gap: 1.5rem !important;
}

.gx-5 {
  column-gap: 3rem !important;
}

.gy-0 {
  row-gap: 0 !important;
}

.gy-1 {
  row-gap: 0.25rem !important;
}

.gy-2 {
  row-gap: 0.5rem !important;
}

.gy-3 {
  row-gap: 1rem !important;
}

.gy-4 {
  row-gap: 1.5rem !important;
}

.gy-5 {
  row-gap: 3rem !important;
}

.col {
  flex: 1 0 0%;
  max-width: 100%;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.col-1 {
  flex: 0 0 6.333333%;
  max-width: 6.333333%;
}

.col-2 {
  flex: 0 0 14.666667%;
  max-width: 14.666667%;
}

.col-3 {
  flex: 0 0 23%;
  max-width: 23%;
}

.col-4 {
  flex: 0 0 31.333333%;
  max-width: 31.333333%;
}

.col-5 {
  flex: 0 0 39.666667%;
  max-width: 39.666667%;
}

.col-6 {
  flex: 0 0 48%;
  max-width: 48%;
}

.col-7 {
  flex: 0 0 56.333333%;
  max-width: 56.333333%;
}

.col-8 {
  flex: 0 0 64.666667%;
  max-width: 64.666667%;
}

.col-9 {
  flex: 0 0 73%;
  max-width: 73%;
}

.col-10 {
  flex: 0 0 81.333333%;
  max-width: 81.333333%;
}

.col-11 {
  flex: 0 0 89.666667%;
  max-width: 89.666667%;
}

.col-12 {
  flex: 0 0 98%;
  max-width: 98%;
}

/* Colunas responsivas */
@media (min-width: 576px) { /* sm */
  .col-sm-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-sm-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-sm-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-sm-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-sm-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-sm-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-sm-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-sm-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-sm-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-sm-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-sm-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-sm-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 768px) { /* md */
  .col-md-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-md-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-md-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-md-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-md-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-md-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-md-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-md-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-md-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-md-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-md-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media (min-width: 992px) { /* lg */
  .col-lg-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-lg-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-lg-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-lg-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-lg-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-lg-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-lg-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-lg-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-lg-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-lg-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-lg-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-lg-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 1200px) { /* xl */
  .col-xl-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-xl-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-xl-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-xl-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-xl-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-xl-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-xl-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-xl-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-xl-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-xl-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-xl-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-xl-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 1400px) { /* xxl */
  .col-xxl-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-xxl-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-xxl-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-xxl-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-xxl-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-xxl-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-xxl-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-xxl-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-xxl-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-xxl-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-xxl-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-xxl-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
.ampliacao-panel {
  max-width: 60vw !important;
}

.popover-content {
  max-height: 150px;
}

app-form-projetos thead tr th {
  font-family: "Barlow", sans-serif !important;
  font-weight: 500 !important;
  font-size: 18px !important;
  line-height: 100% !important;
}

app-form-projetos .mat-mdc-header-cell {
  border: none !important;
}

app-form-projetos .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #AE0F0A !important;
  background-color: #AE0F0A !important;
}

.content {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.disabled-button {
  background-color: rgb(112, 111, 111) !important;
  color: white;
  border: 2px solid rgb(112, 111, 111) !important;
  cursor: not-allowed;
}

.header {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.header .mat-mdc-form-field {
  width: 100% !important;
}
.header .filtered-more-options {
  width: 100%;
  display: flex;
  flex-direction: column;
}
@media (max-width: 1024px) {
  .header .filtered-more-options {
    width: 98%;
  }
}
.header .filtered-more-options .mat-mdc-form-field {
  width: 100% !important;
}
.header .filtered-more-options .row-filter button {
  cursor: pointer;
  padding: 1rem 2rem;
  background-color: rgb(174, 15, 10);
  color: #fff;
  border: none;
  border-radius: 0.6rem;
  width: 100%;
}
@media (max-width: 1024px) {
  .header .filtered-more-options .row-filter button {
    margin-top: 15px;
  }
}
@media (max-width: 1024px) {
  .header {
    width: 98%;
  }
}

.legend {
  border-bottom: 1px solid black;
  padding: 1rem;
  font-weight: bold;
  margin: 1rem auto;
  display: flex;
  width: 100%;
}
.legend .btn-adc {
  display: flex;
  margin-left: 16px;
  font-family: "Barlow", sans-serif !important;
  min-width: 150px;
  align-items: flex-start;
}
.legend .btn-adc img {
  width: 24px;
}

.actions-cell button {
  float: right;
}

.mat-expansion-panel-body {
  padding: 0rem !important;
}

.button-list {
  box-shadow: 1px 1px 1px 1px #cdcdcd;
  padding: 0.5rem 5rem;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  margin-bottom: 6px;
}
.button-list .spacer {
  flex: 1;
}
.button-list .mat-icon {
  margin-left: 0.5rem;
}

.header-more-filter-btn-component {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.table-component table {
  table-layout: fixed;
}
@media (max-width: 1024px) {
  .table-component {
    width: 98%;
  }
}

@media (min-width: 1025px) {
  .header {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
  }
  .header .mat-mdc-form-field {
    width: 20% !important;
  }
  .header .filtered-more-options {
    width: 75%;
  }
  .header .filtered-more-options .mat-mdc-form-field {
    width: 70% !important;
  }
  .header .filtered-more-options .row-filter {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .header .filtered-more-options .row-filter button {
    margin: 1rem;
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
table {
  width: 100%;
  box-shadow: none;
  background-color: transparent;
  overflow: auto;
}

tr.example-detail-row {
  height: 0;
}

tr.example-element-row:not(.example-expanded-row):hover {
  background: whitesmoke;
}

tr.example-element-row:not(.example-expanded-row):active {
  background: #efefef;
}

.header-expanded-table .mat-mdc-form-field {
  width: 100%;
}
.header-expanded-table button {
  cursor: pointer;
  padding: 1rem 2rem;
  background-color: rgb(174, 15, 10);
  color: #fff;
  border: none;
  border-radius: 0.6rem;
  width: 100%;
}

.title {
  font-size: 1.5rem;
  display: flex;
  flex-direction: column;
  font-weight: bold;
}
.title .description {
  font-size: 1rem;
  font-weight: normal;
}

.mat-ripple {
  overflow: hidden;
  position: relative;
}
.mat-ripple:not(:empty) {
  transform: translateZ(0);
}

.mat-ripple.mat-ripple-unbounded {
  overflow: visible;
}

.mat-ripple-element {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  transition: opacity, transform 0ms cubic-bezier(0, 0, 0.2, 1);
  transform: scale3d(0, 0, 0);
}
.cdk-high-contrast-active .mat-ripple-element {
  display: none;
}

.cdk-visually-hidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
  outline: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  left: 0;
}
[dir=rtl] .cdk-visually-hidden {
  left: auto;
  right: 0;
}

.cdk-overlay-container, .cdk-global-overlay-wrapper {
  pointer-events: none;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.cdk-overlay-container {
  position: fixed;
  z-index: 1000;
}
.cdk-overlay-container:empty {
  display: none;
}

.cdk-global-overlay-wrapper {
  display: flex;
  position: absolute;
  z-index: 1000;
}

.cdk-overlay-pane {
  position: absolute;
  pointer-events: auto;
  box-sizing: border-box;
  z-index: 1000;
  display: flex;
  max-width: 100%;
  max-height: 100%;
}

.cdk-overlay-backdrop {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  pointer-events: auto;
  -webkit-tap-highlight-color: transparent;
  transition: opacity 400ms cubic-bezier(0.25, 0.8, 0.25, 1);
  opacity: 0;
}
.cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
  opacity: 1;
}
.cdk-high-contrast-active .cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
  opacity: 0.6;
}

.cdk-overlay-dark-backdrop {
  background: rgba(0, 0, 0, 0.32);
}

.cdk-overlay-transparent-backdrop {
  transition: visibility 1ms linear, opacity 1ms linear;
  visibility: hidden;
  opacity: 1;
}
.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {
  opacity: 0;
  visibility: visible;
}

.cdk-overlay-backdrop-noop-animation {
  transition: none;
}

.cdk-overlay-connected-position-bounding-box {
  position: absolute;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  min-width: 1px;
  min-height: 1px;
}

.cdk-global-scrollblock {
  position: fixed;
  width: 100%;
  overflow-y: scroll;
}

textarea.cdk-textarea-autosize {
  resize: none;
}

textarea.cdk-textarea-autosize-measuring {
  padding: 2px 0 !important;
  box-sizing: content-box !important;
  height: auto !important;
  overflow: hidden !important;
}

textarea.cdk-textarea-autosize-measuring-firefox {
  padding: 2px 0 !important;
  box-sizing: content-box !important;
  height: 0 !important;
}

@keyframes cdk-text-field-autofill-start { /*!*/ }
@keyframes cdk-text-field-autofill-end { /*!*/ }
.cdk-text-field-autofill-monitored:-webkit-autofill {
  animation: cdk-text-field-autofill-start 0s 1ms;
}

.cdk-text-field-autofill-monitored:not(:-webkit-autofill) {
  animation: cdk-text-field-autofill-end 0s 1ms;
}

.mat-focus-indicator {
  position: relative;
}
.mat-focus-indicator::before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  display: var(--mat-focus-indicator-display, none);
  border: var(--mat-focus-indicator-border-width, 3px) var(--mat-focus-indicator-border-style, solid) var(--mat-focus-indicator-border-color, transparent);
  border-radius: var(--mat-focus-indicator-border-radius, 4px);
}
.mat-focus-indicator:focus::before {
  content: "";
}

.cdk-high-contrast-active {
  --mat-focus-indicator-display: block;
}

.mat-mdc-focus-indicator {
  position: relative;
}
.mat-mdc-focus-indicator::before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  display: var(--mat-mdc-focus-indicator-display, none);
  border: var(--mat-mdc-focus-indicator-border-width, 3px) var(--mat-mdc-focus-indicator-border-style, solid) var(--mat-mdc-focus-indicator-border-color, transparent);
  border-radius: var(--mat-mdc-focus-indicator-border-radius, 4px);
}
.mat-mdc-focus-indicator:focus::before {
  content: "";
}

.cdk-high-contrast-active {
  --mat-mdc-focus-indicator-display: block;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
body {
  font-family: "Barlow", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
}

h1 {
  font-size: 64px;
  line-height: 78px;
}

h2 {
  font-size: 56px;
  line-height: 68px;
}

h3 {
  font-size: 48px;
  line-height: 58px;
}

h4 {
  font-size: 40px;
  line-height: 48px;
}

h5 {
  font-size: 32px;
  line-height: 39px;
}

h6 {
  font-size: 24px;
  line-height: 29px;
}

a {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  color: rgb(174, 15, 10);
  cursor: pointer;
  text-decoration: underline;
}

caption {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
}

th {
  font-weight: 700;
  cursor: pointer;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
.p-0 {
  padding: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.pr-0 {
  padding-right: 0px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pl-0 {
  padding-left: 0px;
}

.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}

.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}

.m-0 {
  margin: 0px;
}

.mt-0 {
  margin-top: 0px;
}

.mr-0 {
  margin-right: 0px;
}

.mb-0 {
  margin-bottom: 0px;
}

.ml-0 {
  margin-left: 0px;
}

.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}

.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.p-1 {
  padding: 8px;
}

.pt-1 {
  padding-top: 8px;
}

.pr-1 {
  padding-right: 8px;
}

.pb-1 {
  padding-bottom: 8px;
}

.pl-1 {
  padding-left: 8px;
}

.px-1 {
  padding-left: 8px;
  padding-right: 8px;
}

.py-1 {
  padding-top: 8px;
  padding-bottom: 8px;
}

.m-1 {
  margin: 8px;
}

.mt-1 {
  margin-top: 8px;
}

.mr-1 {
  margin-right: 8px;
}

.mb-1 {
  margin-bottom: 8px;
}

.ml-1 {
  margin-left: 8px;
}

.mx-1 {
  margin-left: 8px;
  margin-right: 8px;
}

.my-1 {
  margin-top: 8px;
  margin-bottom: 8px;
}

.p-2 {
  padding: 16px;
}

.pt-2 {
  padding-top: 16px;
}

.pr-2 {
  padding-right: 16px;
}

.pb-2 {
  padding-bottom: 16px;
}

.pl-2 {
  padding-left: 16px;
}

.px-2 {
  padding-left: 16px;
  padding-right: 16px;
}

.py-2 {
  padding-top: 16px;
  padding-bottom: 16px;
}

.m-2 {
  margin: 16px;
}

.mt-2 {
  margin-top: 16px;
}

.mr-2 {
  margin-right: 16px;
}

.mb-2 {
  margin-bottom: 16px;
}

.ml-2 {
  margin-left: 16px;
}

.mx-2 {
  margin-left: 16px;
  margin-right: 16px;
}

.my-2 {
  margin-top: 16px;
  margin-bottom: 16px;
}

.p-3 {
  padding: 24px;
}

.pt-3 {
  padding-top: 24px;
}

.pr-3 {
  padding-right: 24px;
}

.pb-3 {
  padding-bottom: 24px;
}

.pl-3 {
  padding-left: 24px;
}

.px-3 {
  padding-left: 24px;
  padding-right: 24px;
}

.py-3 {
  padding-top: 24px;
  padding-bottom: 24px;
}

.m-3 {
  margin: 24px;
}

.mt-3 {
  margin-top: 24px;
}

.mr-3 {
  margin-right: 24px;
}

.mb-3 {
  margin-bottom: 24px;
}

.ml-3 {
  margin-left: 24px;
}

.mx-3 {
  margin-left: 24px;
  margin-right: 24px;
}

.my-3 {
  margin-top: 24px;
  margin-bottom: 24px;
}

.p-4 {
  padding: 32px;
}

.pt-4 {
  padding-top: 32px;
}

.pr-4 {
  padding-right: 32px;
}

.pb-4 {
  padding-bottom: 32px;
}

.pl-4 {
  padding-left: 32px;
}

.px-4 {
  padding-left: 32px;
  padding-right: 32px;
}

.py-4 {
  padding-top: 32px;
  padding-bottom: 32px;
}

.m-4 {
  margin: 32px;
}

.mt-4 {
  margin-top: 32px;
}

.mr-4 {
  margin-right: 32px;
}

.mb-4 {
  margin-bottom: 32px;
}

.ml-4 {
  margin-left: 32px;
}

.mx-4 {
  margin-left: 32px;
  margin-right: 32px;
}

.my-4 {
  margin-top: 32px;
  margin-bottom: 32px;
}

.p-5 {
  padding: 40px;
}

.pt-5 {
  padding-top: 40px;
}

.pr-5 {
  padding-right: 40px;
}

.pb-5 {
  padding-bottom: 40px;
}

.pl-5 {
  padding-left: 40px;
}

.px-5 {
  padding-left: 40px;
  padding-right: 40px;
}

.py-5 {
  padding-top: 40px;
  padding-bottom: 40px;
}

.m-5 {
  margin: 40px;
}

.mt-5 {
  margin-top: 40px;
}

.mr-5 {
  margin-right: 40px;
}

.mb-5 {
  margin-bottom: 40px;
}

.ml-5 {
  margin-left: 40px;
}

.mx-5 {
  margin-left: 40px;
  margin-right: 40px;
}

.my-5 {
  margin-top: 40px;
  margin-bottom: 40px;
}

.p-6 {
  padding: 48px;
}

.pt-6 {
  padding-top: 48px;
}

.pr-6 {
  padding-right: 48px;
}

.pb-6 {
  padding-bottom: 48px;
}

.pl-6 {
  padding-left: 48px;
}

.px-6 {
  padding-left: 48px;
  padding-right: 48px;
}

.py-6 {
  padding-top: 48px;
  padding-bottom: 48px;
}

.m-6 {
  margin: 48px;
}

.mt-6 {
  margin-top: 48px;
}

.mr-6 {
  margin-right: 48px;
}

.mb-6 {
  margin-bottom: 48px;
}

.ml-6 {
  margin-left: 48px;
}

.mx-6 {
  margin-left: 48px;
  margin-right: 48px;
}

.my-6 {
  margin-top: 48px;
  margin-bottom: 48px;
}

.p-7 {
  padding: 56px;
}

.pt-7 {
  padding-top: 56px;
}

.pr-7 {
  padding-right: 56px;
}

.pb-7 {
  padding-bottom: 56px;
}

.pl-7 {
  padding-left: 56px;
}

.px-7 {
  padding-left: 56px;
  padding-right: 56px;
}

.py-7 {
  padding-top: 56px;
  padding-bottom: 56px;
}

.m-7 {
  margin: 56px;
}

.mt-7 {
  margin-top: 56px;
}

.mr-7 {
  margin-right: 56px;
}

.mb-7 {
  margin-bottom: 56px;
}

.ml-7 {
  margin-left: 56px;
}

.mx-7 {
  margin-left: 56px;
  margin-right: 56px;
}

.my-7 {
  margin-top: 56px;
  margin-bottom: 56px;
}

.p-8 {
  padding: 64px;
}

.pt-8 {
  padding-top: 64px;
}

.pr-8 {
  padding-right: 64px;
}

.pb-8 {
  padding-bottom: 64px;
}

.pl-8 {
  padding-left: 64px;
}

.px-8 {
  padding-left: 64px;
  padding-right: 64px;
}

.py-8 {
  padding-top: 64px;
  padding-bottom: 64px;
}

.m-8 {
  margin: 64px;
}

.mt-8 {
  margin-top: 64px;
}

.mr-8 {
  margin-right: 64px;
}

.mb-8 {
  margin-bottom: 64px;
}

.ml-8 {
  margin-left: 64px;
}

.mx-8 {
  margin-left: 64px;
  margin-right: 64px;
}

.my-8 {
  margin-top: 64px;
  margin-bottom: 64px;
}

.p-9 {
  padding: 72px;
}

.pt-9 {
  padding-top: 72px;
}

.pr-9 {
  padding-right: 72px;
}

.pb-9 {
  padding-bottom: 72px;
}

.pl-9 {
  padding-left: 72px;
}

.px-9 {
  padding-left: 72px;
  padding-right: 72px;
}

.py-9 {
  padding-top: 72px;
  padding-bottom: 72px;
}

.m-9 {
  margin: 72px;
}

.mt-9 {
  margin-top: 72px;
}

.mr-9 {
  margin-right: 72px;
}

.mb-9 {
  margin-bottom: 72px;
}

.ml-9 {
  margin-left: 72px;
}

.mx-9 {
  margin-left: 72px;
  margin-right: 72px;
}

.my-9 {
  margin-top: 72px;
  margin-bottom: 72px;
}

.p-10 {
  padding: 80px;
}

.pt-10 {
  padding-top: 80px;
}

.pr-10 {
  padding-right: 80px;
}

.pb-10 {
  padding-bottom: 80px;
}

.pl-10 {
  padding-left: 80px;
}

.px-10 {
  padding-left: 80px;
  padding-right: 80px;
}

.py-10 {
  padding-top: 80px;
  padding-bottom: 80px;
}

.m-10 {
  margin: 80px;
}

.mt-10 {
  margin-top: 80px;
}

.mr-10 {
  margin-right: 80px;
}

.mb-10 {
  margin-bottom: 80px;
}

.ml-10 {
  margin-left: 80px;
}

.mx-10 {
  margin-left: 80px;
  margin-right: 80px;
}

.my-10 {
  margin-top: 80px;
  margin-bottom: 80px;
}

html {
  --mdc-outlined-text-field-focus-outline-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mdc-outlined-text-field-focus-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-option-selected-state-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-datepicker-toggle-active-state-icon-color: rgba(
    174,
    15,
    10,
    1
  ) !important;
  --mdc-filled-text-field-focus-active-indicator-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-sidenav-content-background-color: white !important;
}

/* You can add global styles to this file, and also import other style files */
/* Angular 15 adds grey background on mat form components */
/* below removes that background color */
/* Manipulate initial background color*/
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

/*Manipulate background color on hover and focus*/
.mat-mdc-form-field-focus-overlay {
  background-color: transparent !important;
}

.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {
  width: 0px;
  padding-left: 6px;
  padding-right: 6px;
}
.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted span {
  display: none;
}

/* Pagination menu */
.g-bubble-container {
  display: flex;
  gap: 4px;
  margin-left: 8px;
}

.g-bubble {
  background-color: rgb(245, 246, 249);
  border-radius: 4px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(34, 36, 40) !important;
  font-size: 1rem;
  cursor: pointer;
  transition: 0.3s;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-align: center;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}

.g-bubble:hover {
  background-color: rgb(189, 188, 188);
  color: rgb(245, 246, 249);
}

.g-bubble__active {
  background-color: rgb(227, 6, 19);
  color: rgb(227, 227, 227) !important;
  box-shadow: 0px 5px 14px 0px rgba(0, 0, 0, 0.12), 0px 9px 10px 0px rgba(0, 0, 0, 0.14), 0px 5px 5px 0px rgba(0, 0, 0, 0.2);
}

mat-paginator {
  background: transparent !important;
}

.mat-mdc-paginator-range-actions {
  margin-right: 12px !important;
}

.mat-mdc-paginator-container {
  justify-content: center !important;
}

.mat-mdc-paginator-navigation-next,
.mat-mdc-paginator-navigation-previous {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: rgb(34, 36, 40) !important;
  padding: 0 !important;
  border-radius: 4px !important;
  width: 34px !important;
  height: 34px !important;
  background-color: rgb(245, 246, 249) !important;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}

/* End of pagination menu */
body {
  margin: 0;
}

.snackbar {
  width: 50vw;
  margin: 10px 0px !important;
}
.snackbar .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
}
.snackbar .mdc-snackbar__label {
  color: black !important;
}
.snackbar .mat-icon {
  margin-right: 12px;
}

.snackbar-custom {
  width: 50vw;
  margin-top: 75px !important;
}

.snacbar-warning {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-warning .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid #e0ac08;
}
.snacbar-warning .mdc-snackbar__label {
  color: black !important;
}
.snacbar-warning .mat-icon {
  margin-right: 12px;
}

.snacbar-sucess {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-sucess .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid green;
}
.snacbar-sucess .mdc-snackbar__label {
  color: black !important;
}
.snacbar-sucess .mat-icon {
  margin-right: 12px;
}

.snacbar-error {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-error .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid red;
}
.snacbar-error .mdc-snackbar__label {
  color: black !important;
}
.snacbar-error .mat-icon {
  margin-right: 12px;
}

.flex {
  display: flex;
}

.mat-mdc-menu-panel {
  overflow: hidden !important;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .menu-header {
  font-size: 12px;
  padding: 1rem;
  padding-bottom: 0.25rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item {
  margin-left: 1rem;
  padding-left: 0;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:first-of-type {
  margin-top: 0.75rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:not(:last-child) {
  border-bottom: 1px solid rgb(189, 188, 188);
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 3000;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sort-icon-container {
  display: inline-flex;
  align-items: center;
}
.sort-icon-container mat-icon {
  height: 1rem;
  width: 1rem;
}

@media (max-width: 767px) {
  app-edit-contract .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40% !important;
    height: 45px;
  }
}

.btn-primary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(174, 15, 10);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40%;
    height: 45px;
  }
}
.btn-primary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
  background: white;
  color: rgb(174, 15, 10);
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: 2px solid rgb(174, 15, 10);
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}
.btn-secondary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(189, 188, 188);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}

/* 
  IONIC components
*/
ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-item.no-padding-full {
  --padding-end: 0;
  --padding-start: 0;
  --inner-padding-end: 0;
  --inner-padding-start: 0;
}

ion-checkbox {
  --checkbox-background-checked: rgba(174, 15, 10, 1);
  --border-color-checked: rgba(174, 15, 10, 1);
}

ion-input.custom-input {
  --border-color: rgba(135, 135, 135, 1);
  --padding-top: 5px;
  --highlight-color: rgba(135, 135, 135, 1);
}

ion-input.custom-input-user {
  --border-color: #EFEFEF;
  --padding-top: 5px;
  --highlight-color: rgba(135, 135, 135, 1);
}

ion-input.width-full {
  --border-color: #EFEFEF !important;
  --padding-top: 5px;
  --highlight-color: rgb(37, 19, 19);
}

.filter-panel {
  max-width: 100vw !important;
}

.date-select-modal-filter .mdc-text-field {
  height: 35px;
}
.date-select-modal-filter .mat-mdc-form-field-infix {
  height: 35px;
  min-height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.date-select-modal-filter .select-year .mat-mdc-text-field-wrapper {
  background-color: #f4f4f4;
  border: 1px solid rgb(189, 188, 188);
}
.date-select-modal-filter .mdc-notched-outline__leading {
  border: none !important;
}
.date-select-modal-filter .mdc-notched-outline__notch {
  border: none !important;
}
.date-select-modal-filter .mdc-notched-outline__trailing {
  border: none !important;
}

@media (min-width: 1025px) {
  .filter-panel {
    max-height: 33rem !important;
    min-width: 60vw;
  }
  .anotation-panel {
    max-width: 30rem !important;
    max-height: 30rem !important;
    min-width: 50vw;
  }
  .historic-panel {
    min-width: 49.5rem;
    min-height: 35.625rem;
    min-width: 50vw;
  }
  .segments-panel {
    width: 72vw;
    min-width: 760px;
    max-width: 1100px !important;
    max-height: 90vh !important;
  }
  .new-highway-modal-panel {
    min-width: 49.5rem;
    min-height: 23.625rem;
    min-width: 50vw;
  }
}
@media (max-width: 1024px) {
  .btn-actions {
    margin-right: 15px;
  }
  .filter-panel {
    min-height: 30rem;
    max-width: 100vw !important;
    min-width: 90vw;
  }
  .historic-panel {
    max-width: 49.5rem;
    min-width: 90vw !important;
  }
  .segments-panel {
    max-width: 90vw !important;
    min-width: 90vw !important;
    max-height: 90vh !important;
  }
  .new-highway-modal-panel {
    max-width: 49.5rem;
    min-width: 90vw !important;
  }
}
@media (max-width: 1024px) {
  .anotation-panel {
    width: 90%;
  }
}
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

@media (max-width: 1024px) {
  .mat-mdc-form-field-label {
    font-size: 0.8rem;
    /* Tamanho de fonte para dispositivos móveis */
  }
}
.button_cad {
  background-color: rgb(174, 15, 10);
  padding: 0.5rem 2rem;
  border-radius: 0.5rem;
  color: #fff;
  font-style: none;
  text-decoration: none;
}
.button_cad mat-icon {
  color: #fff !important;
}

::ng-deep.mat-mdc-card-header-text {
  display: none !important;
}

.input-error {
  border: 1px solid red; /* Ajuste o estilo conforme necessário */
}

.card-mobile {
  min-height: 10rem;
  margin: 1rem auto;
  border: 1px solid #cdcdcd;
}
.card-mobile .mat-mdc-card-header {
  width: 90%;
  display: flex;
  margin: auto;
  justify-content: space-between;
  padding: 0rem;
}
.card-mobile .mat-mdc-card-header p {
  font-weight: bolder;
  font-size: 1.2rem;
  text-transform: uppercase;
}
.card-mobile .mat-mdc-card-header span,
.card-mobile .mat-mdc-card-header .subtitle {
  font-size: 1rem;
  font-weight: normal;
  color: #cdcdcd;
}
@media (max-width: 1024px) {
  .card-mobile .mat-mdc-card-header {
    width: 100%;
    margin: 0 16px;
  }
}
.card-mobile .mat-mdc-card-footer {
  margin: 1rem 0rem;
  border-top: 1px solid black;
  display: flex;
  align-items: center;
}
.card-mobile .mat-mdc-card-footer button {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.card-mobile .extension {
  font-weight: bold;
  color: rgb(174, 15, 10);
}
@media (max-width: 1024px) {
  .card-mobile .formatAnotation {
    padding: 0 16px;
  }
}
.card-mobile .content-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-mobile .content-status {
  width: 40%;
  align-items: center;
  display: flex;
  flex-direction: column;
}
.card-mobile .content-status p {
  font-weight: bold;
}

.card-mobile-empty {
  border: 1px solid #cdcdcd;
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-button.more-filters-btn {
  --background: rgba(174, 15, 10, 1);
  --color: white;
  --border-radius: 10px;
  width: 100%;
  max-width: 15rem;
  text-transform: capitalize;
  font-size: 0.9rem;
  height: 100%;
  font-weight: 600;
  letter-spacing: 0.08em;
}

ion-item.fast-filters {
  padding: 0.25rem 0rem;
}

ion-chip.fast-filter-active-primary {
  background-color: rgb(40, 186, 98);
  color: white;
}

ion-chip.fast-filter-active-secondary {
  background-color: rgb(235, 68, 90);
  color: white;
}

ion-chip.fast-filter-active-primary-contract {
  color: #AE0F0A;
  border: 1px solid #AE0F0A;
  background: #E4ADB5;
}

ion-chip.fast-filter-active-secondary-contract {
  color: #AE0F0A;
  border: 1px solid #AE0F0A;
  background: #E4ADB5;
}

.more-filters-btn-row {
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.more-filters-btn-row button {
  margin: 5px;
}
@media (max-width: 767px) {
  .more-filters-btn-row button {
    margin: 5px 0;
  }
}

.status-container {
  display: flex;
  align-items: center;
}
.status-container .mat-icon {
  width: 1rem;
}
.status-container .status-icon {
  font-size: 8px;
  align-content: center;
  text-align: center;
}
.status-container .active {
  color: rgb(40, 186, 98);
}
.status-container .inactive {
  color: rgb(235, 68, 90);
}

ion-textarea,
ion-input {
  --border-color: rgba(87, 87, 86, 1);
  --padding-top: 5px !important;
  --highlight-color: rgba(135, 135, 135, 1);
  --highlight-color-focused: rgba(135, 135, 135, 1) !important;
  --highlight-color-valid: rgba(135, 135, 135, 1) !important;
  --highlight-color-invalid: rgba(174, 15, 10, 1) !important;
}

ion-alert.custom-alert {
  --backdrop-opacity: 0.7;
}

ion-list.filtered-list {
  display: flex;
  flex-wrap: wrap;
}
ion-list.filtered-list span {
  padding: 0.75rem 0;
  margin: 0 0.75rem;
  border-bottom: 1px solid rgb(189, 188, 188);
  width: 100%;
}

ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-toast.snackbar-toast {
  --box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
  --width: fit-content;
  --border-radius: 0.75rem;
  --white-space: pre-line;
}

ion-toast.snackbar-toast::part(container) {
  background: #fff;
  color: rgb(34, 36, 40);
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 0.75rem;
}

ion-toast.snackbar-toast.toast-success::part(container) {
  border: 1px solid rgb(45, 211, 111);
}
ion-toast.snackbar-toast.toast-success::part(icon) {
  color: rgb(45, 211, 111);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-error::part(container) {
  border: 1px solid rgb(235, 68, 90);
}
ion-toast.snackbar-toast.toast-error::part(icon) {
  color: rgb(235, 68, 90);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-right {
  --start: right;
  --box-shadow: none;
  --background: none;
}
ion-toast.snackbar-toast.toast-right::part(container) {
  transform: translateY(72px) !important;
  box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
}

::ng-deep.mat-tab-label {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: red !important;
  font-weight: 700;
}

/* Styles for the active tab label */
::ng-deep.mat-tab-label.mat-tab-label-active {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: red !important;
  font-weight: 700;
}

::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline {
  border-color: #2b2b2b;
}

::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #2b2b2b;
}

.mat-mdc-paginator-navigation-next, .mat-mdc-paginator-navigation-previous {
  box-shadow: none !important;
}

.g-bubble {
  box-shadow: none !important;
}

app-modal-historic-segment {
  display: block;
  width: 100%;
  height: 45em;
}

.column-flex {
  display: flex;
  flex-flow: column;
}

.master-icon {
  background-color: rgb(255, 202, 34);
  color: rgb(34, 36, 40);
  border-radius: 10px;
  align-self: flex-start;
  font-size: 10px;
  padding: 0px 9px;
  margin: 6px 0;
  line-height: 17px;
  font-weight: 600;
}
.master-icon.center-horizontal {
  place-self: center;
}

ion-popover {
  --min-width: 375px;
  --max-width: 500px;
}

.custom-tooltip-menu {
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.custom-tooltip-menu .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {
  background: none;
}
.custom-tooltip-menu .mdc-evolution-chip__text-label {
  color: #c00;
}

.custom-tooltip-menu .filter-title {
  font-size: 12px;
  font-weight: bold;
  color: #333;
  display: block;
  margin-bottom: 4px;
  border-bottom: 1px solid grey;
}

.custom-tooltip-menu .tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.custom-tooltip-menu mat-chip {
  border: 1px solid #c00;
  height: 20px;
}

.custom-tooltip-menu mat-chip mat-icon {
  color: #c00 !important;
  cursor: pointer;
  font-size: 14px !important;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0px !important;
}

.custom-tooltip-menu mat-chip .mdc-evolution-chip__text-label {
  color: #c00 !important;
  cursor: pointer;
  font-size: 12px !important;
  opacity: 1;
}

::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline {
  border: 1px solid #c00 !important;
}

::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #c00 !important;
}

ion-toggle {
  --handle-background-checked: rgba(174, 15, 10, 1);
  --track-background-checked: rgba(174, 15, 10, 0.38);
}

app-list-contracts thead {
  background: #F4F4F4 !important;
}

app-table-default thead {
  background: #F4F4F4 !important;
}

.mat-expansion-panel-body {
  padding: 0px !important;
}

.mat-mdc-paginator-range-actions {
  overflow-wrap: anywhere !important;
  flex-grow: 1;
  justify-content: center !important;
  position: relative !important;
}

.mat-mdc-paginator-container:has(.mat-mdc-paginator-page-size) .mat-mdc-paginator-range-actions .mat-mdc-paginator-range-label {
  position: absolute !important;
  left: 0 !important;
}

.mat-mdc-tab {
  background-color: #F4F4F4 !important;
}

.mdc-tab--active {
  background-color: white !important;
}

@media (max-width: 1025px) {
  #paginator {
    width: 100%;
  }
}

ion-icon.search-icon-absolute {
  position: absolute;
  left: 16px;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 3;
}

ion-input.search-input label.input-wrapper {
  --padding-start: 55px;
}
.mat-mdc-icon-button[disabled] {
  cursor: default;
  pointer-events: auto;
  opacity: 0.38;
}

.mat-mdc-unelevated-button[disabled] {
  cursor: default;
  pointer-events: auto;
  opacity: 0.38;
}

.item-inner {
  padding-right: 0 !important;
}

@media (max-width: 496px) {
  .mat-mdc-paginator-page-size-label {
    display: none !important;
  }
}

.comentarios .mdc-text-field--outlined {
  --mdc-outlined-text-field-outline-width: 1px;
  --mdc-outlined-text-field-outline-color: #EFEFEF; /* Borda normal */
  --mdc-outlined-text-field-focus-outline-color: #EFEFEF; /* Borda ao focar */
  --mdc-outlined-text-field-container-shape: 4px;
}

.g-0 {
  gap: 0 !important;
}

.g-1 {
  gap: 0.25rem !important;
}

.g-2 {
  gap: 0.5rem !important;
}

.g-3 {
  gap: 1rem !important;
}

.g-4 {
  gap: 1.5rem !important;
}

.g-5 {
  gap: 3rem !important;
}

.gx-0 {
  column-gap: 0 !important;
}

.gx-1 {
  column-gap: 0.25rem !important;
}

.gx-2 {
  column-gap: 0.5rem !important;
}

.gx-3 {
  column-gap: 1rem !important;
}

.gx-4 {
  column-gap: 1.5rem !important;
}

.gx-5 {
  column-gap: 3rem !important;
}

.gy-0 {
  row-gap: 0 !important;
}

.gy-1 {
  row-gap: 0.25rem !important;
}

.gy-2 {
  row-gap: 0.5rem !important;
}

.gy-3 {
  row-gap: 1rem !important;
}

.gy-4 {
  row-gap: 1.5rem !important;
}

.gy-5 {
  row-gap: 3rem !important;
}

.col {
  flex: 1 0 0%;
  max-width: 100%;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.col-1 {
  flex: 0 0 6.333333%;
  max-width: 6.333333%;
}

.col-2 {
  flex: 0 0 14.666667%;
  max-width: 14.666667%;
}

.col-3 {
  flex: 0 0 23%;
  max-width: 23%;
}

.col-4 {
  flex: 0 0 31.333333%;
  max-width: 31.333333%;
}

.col-5 {
  flex: 0 0 39.666667%;
  max-width: 39.666667%;
}

.col-6 {
  flex: 0 0 48%;
  max-width: 48%;
}

.col-7 {
  flex: 0 0 56.333333%;
  max-width: 56.333333%;
}

.col-8 {
  flex: 0 0 64.666667%;
  max-width: 64.666667%;
}

.col-9 {
  flex: 0 0 73%;
  max-width: 73%;
}

.col-10 {
  flex: 0 0 81.333333%;
  max-width: 81.333333%;
}

.col-11 {
  flex: 0 0 89.666667%;
  max-width: 89.666667%;
}

.col-12 {
  flex: 0 0 98%;
  max-width: 98%;
}

/* Colunas responsivas */
@media (min-width: 576px) { /* sm */
  .col-sm-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-sm-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-sm-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-sm-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-sm-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-sm-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-sm-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-sm-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-sm-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-sm-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-sm-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-sm-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 768px) { /* md */
  .col-md-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-md-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-md-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-md-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-md-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-md-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-md-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-md-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-md-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-md-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-md-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media (min-width: 992px) { /* lg */
  .col-lg-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-lg-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-lg-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-lg-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-lg-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-lg-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-lg-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-lg-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-lg-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-lg-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-lg-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-lg-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 1200px) { /* xl */
  .col-xl-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-xl-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-xl-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-xl-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-xl-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-xl-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-xl-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-xl-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-xl-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-xl-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-xl-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-xl-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 1400px) { /* xxl */
  .col-xxl-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-xxl-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-xxl-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-xxl-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-xxl-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-xxl-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-xxl-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-xxl-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-xxl-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-xxl-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-xxl-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-xxl-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
.ampliacao-panel {
  max-width: 60vw !important;
}

.popover-content {
  max-height: 150px;
}

app-form-projetos thead tr th {
  font-family: "Barlow", sans-serif !important;
  font-weight: 500 !important;
  font-size: 18px !important;
  line-height: 100% !important;
}

app-form-projetos .mat-mdc-header-cell {
  border: none !important;
}

app-form-projetos .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #AE0F0A !important;
  background-color: #AE0F0A !important;
}

.entities-list-container {
  padding: 1rem;
  background-color: white;
}
.entities-list-container .entitie-filters {
  display: flex;
  flex-wrap: wrap;
  transform: var(--mat-mdc-form-field-label-transform, translateY(0%) translateX(calc(1 * (0px + var(--mat-mdc-form-field-label-offset-x, 0px)))));
}
@media (max-width: 1024px) {
  .entities-list-container .entitie-filters {
    flex-direction: column;
  }
}
.entities-list-container .entitie-filters .search-input {
  border: 1px solid;
  border-radius: 7px;
  display: flex;
  align-items: center;
  box-shadow: 1px 1px 1px 1px #cdcdcd;
  flex-grow: 3;
}
.entities-list-container h6 {
  margin-bottom: 1rem;
  margin-top: 1rem;
}
.entities-list-container .filtros {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.entities-list-container .filtros .fast-filter {
  width: 30%;
  align-items: center;
  background: transparent;
}
.entities-list-container .filtros .fast-filter .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {
  background-color: white;
  border: 1px solid rgb(112, 111, 111);
}
.entities-list-container .filtros .fast-filter .filter-by-active-entitie.mat-mdc-chip-selected.mdc-evolution-chip--selected {
  background-color: rgb(40, 186, 98);
}
.entities-list-container .filtros .fast-filter .filter-by-inactive-entitie.mat-mdc-chip-selected.mdc-evolution-chip--selected {
  background-color: rgb(235, 68, 90);
}
.entities-list-container .filtros .fast-filter .mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {
  display: none;
}
.entities-list-container .filtros .fast-filter span {
  color: rgb(112, 111, 111);
  font-weight: 400;
  align-content: center;
}
.entities-list-container .filtros .button-list {
  box-shadow: 1px 1px 1px 1px #cdcdcd;
  padding: 0.5rem 5rem;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  margin-bottom: 6px;
}
.entities-list-container .filtros .button-list .spacer {
  flex: 1;
}
.entities-list-container .filtros .button-list .mat-icon {
  margin-left: 0.5rem;
}
.entities-list-container .more-filters {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.entities-list-container .more-filters .mat-mdc-form-field {
  margin: 0rem 2rem;
  margin-bottom: -1rem;
}
.entities-list-container .more-filters .mat-picker {
  margin-right: 0rem !important;
}
.entities-list-container mat-form-field {
  margin-bottom: 16px;
}
.entities-list-container table {
  width: 100%;
}
.entities-list-container th {
  font-weight: 700;
}
.entities-list-container .entitie-list-table-wrapper {
  overflow: auto;
}
.entities-list-container .entitie-list-table-wrapper th {
  cursor: pointer;
}
.entities-list-container .status-container {
  display: flex;
  align-items: center;
}
.entities-list-container .status-container .mat-icon {
  width: 1rem;
}
.entities-list-container .status-container .status-icon {
  font-size: 8px;
  align-content: center;
  text-align: center;
}
.entities-list-container .status-container .active {
  color: rgb(40, 186, 98);
}
.entities-list-container .status-container .inactive {
  color: rgb(235, 68, 90);
}
.entities-list-container .create-entitie-link {
  display: flex;
  margin-bottom: 1.5rem;
}
.entities-list-container .create-entitie-link mat-icon {
  height: 1rem;
}
.entities-list-container .icon-entitie-actions-menu {
  color: rgb(174, 15, 10);
}

::ng-deep .mat-calendar-body-selected {
  background-color: red !important;
}

::ng-deep .mat-calendar-body-cell-content {
  border-radius: 0rem !important;
}

::ng-deep .mat-calendar-body-selected.mat-calendar-body-today {
  box-shadow: none;
}

@media (max-width: 1025px) {
  .filtros {
    flex-direction: column;
    align-items: center;
  }
  .fast-filter {
    width: 100% !important;
    margin: 1rem 0rem;
  }
  .more-filters {
    width: 100%;
    margin: 1rem auto;
    flex-direction: column;
    align-items: center;
  }
  .more-filters .mat-mdc-form-field {
    width: 100%;
    margin: 0rem !important;
    margin-bottom: 1rem;
  }
  .label {
    font-size: 0.7rem;
  }
}
::ng-deep .mat-mdc-form-field-label {
  transform: none !important;
}

.mat-mdc-form-field-label {
  transform: none !important;
}

@media (min-width: 1025px) {
  .fast-filter {
    width: 50% !important;
    margin: 1rem 0rem;
  }
  .header-expanded-table {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .header-expanded-table .mat-mdc-form-field {
    width: 70%;
  }
  .header-expanded-table button {
    width: 40% !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.paginator-segment {
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.paginator-segment p {
  width: 100%;
  font-size: 1.5rem;
  font-weight: bold;
}

@media (min-width: 1025px) {
  .paginator-segment {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .paginator-segment p {
    width: 50%;
    font-size: 1.5rem;
    font-weight: bold;
  }
}
@media (min-width: 1025px) {
  #paginator {
    width: 80%;
  }
  .paginator-segment {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .paginator-segment p {
    width: 20%;
    font-size: 1.5rem;
    font-weight: bold;
  }
}
.importar {
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid rgb(174, 15, 10);
  border-radius: 8px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/components/contracts/rodovias-abrangidas/rodovias-abrangidas.component.scss","webpack://./node_modules/@angular/material/core/ripple/_ripple.scss","webpack://./node_modules/@angular/cdk/a11y/_index.scss","webpack://./node_modules/@angular/cdk/overlay/_index.scss","webpack://./node_modules/@angular/cdk/text-field/_index.scss","webpack://./node_modules/@angular/material/core/focus-indicators/_private.scss","webpack://./node_modules/@angular/material/core/style/_layout-common.scss","webpack://./src/theme/variables.scss","webpack://./src/theme/typography.scss","webpack://./src/theme/spacing.scss","webpack://./src/styles.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACKd;EACE,gBAAA;EAIA,kBAAA;ADAJ;ACOI;EACE,wBAAA;ADLN;;ACSE;EACE,iBAAA;ADNJ;;ACSE;EACE,kBAAA;EACA,kBAAA;EACA,oBAAA;EAEA,6DAAA;EAIA,2BAAA;ADVJ;AEyBI;EDXE,aAAA;ADXN;;AEzBE;EACE,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EAIA,mBAAA;EAGA,UAAA;EAGA,wBAAA;EACA,qBAAA;EAMA,OAAA;AFgBJ;AEdI;EACE,UAAA;EACA,QAAA;AFgBN;;AGhCE;EAEE,oBAAA;EAGA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AHgCJ;;AG5BE;EACE,eAAA;EACA,aA3BwB;AH0D5B;AG7BI;EAGE,aAAA;AH6BN;;AGrBE;EACE,aAAA;EACA,kBAAA;EACA,aA1Cc;AHkElB;;AGpBE;EAGE,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,aApDc;EAwDd,aAAA;EACA,eAAA;EACA,gBAAA;AHkBJ;;AGfE;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EAEA,aApEuB;EAqEvB,oBAAA;EACA,wCAAA;EACA,0DAAA;EACA,UAAA;AHgBJ;AGdI;EACE,UAAA;AHgBN;AGXM;EAGE,YAAA;AHWR;;AGNE;EACE,+BAtFqB;AH+FzB;;AGNE;EAEE,qDAAA;EACA,kBAAA;EACA,UAAA;AHQJ;AGFI;EACE,UAAA;EACA,mBAAA;AHIN;;AGAE;EACE,gBAAA;AHGJ;;AGEE;EACE,kBAAA;EACA,aArHc;EA0Hd,aAAA;EAIA,sBAAA;EAGA,cAAA;EACA,eAAA;AHRJ;;AGYE;EACE,eAAA;EAKA,WAAA;EAKA,kBAAA;AHjBJ;;AIhIE;EACE,YAAA;AJmIJ;;AI7HE;EAyCA,yBAAA;EACA,kCAAA;EAxCE,uBAAA;EACA,2BAAA;AJiIJ;;AIxHE;EA6BA,yBAAA;EACA,kCAAA;EA5BE,oBAAA;AJ4HJ;;AIlHE,2CAAA,IAAA,EAAA;AACA,yCAAA,IAAA,EAAA;AAEA;EAEE,+CAAA;AJmHJ;;AIhHE;EAEE,6CAAA;AJkHJ;;AKjJE;EACE,kBAAA;ALoJJ;AKlJI;ECfF,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EDaI,sBAAA;EACA,oBAAA;EACA,iDAAA;EACA,wJAAA;EAYA,4DAAA;AL6IN;AKrII;EACE,WAAA;ALuIN;;AE5FM;EG7BA,oCAAA;AL6HN;;AKxKE;EACE,kBAAA;AL2KJ;AKzKI;ECfF,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EDaI,sBAAA;EACA,oBAAA;EACA,qDAAA;EACA,oKAAA;EAYA,gEAAA;ALoKN;AK5JI;EACE,WAAA;AL8JN;;AEnHM;EG7BA,wCAAA;ALoJN;;AO7MA;;;;;CAAA;ACEA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ARoNF;;AQjNA;;;;;;EAME,qCAAA;EACA,gBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,gBAAA;EACA,eAAA;ARoNF;;AOtRA;;;;;CAAA;AEeE;EACE,YAAA;ATgRJ;;AS9QE;EACE,gBAAA;ATiRJ;;AS/QE;EACE,kBAAA;ATkRJ;;AShRE;EACE,mBAAA;ATmRJ;;ASjRE;EACE,iBAAA;AToRJ;;ASlRE;EACE,iBAAA;EACA,kBAAA;ATqRJ;;ASnRE;EACE,gBAAA;EACA,mBAAA;ATsRJ;;ASnRE;EACE,WAAA;ATsRJ;;ASpRE;EACE,eAAA;ATuRJ;;ASrRE;EACE,iBAAA;ATwRJ;;AStRE;EACE,kBAAA;ATyRJ;;ASvRE;EACE,gBAAA;AT0RJ;;ASxRE;EACE,gBAAA;EACA,iBAAA;AT2RJ;;ASzRE;EACE,eAAA;EACA,kBAAA;AT4RJ;;ASzUE;EACE,YAAA;AT4UJ;;AS1UE;EACE,gBAAA;AT6UJ;;AS3UE;EACE,kBAAA;AT8UJ;;AS5UE;EACE,mBAAA;AT+UJ;;AS7UE;EACE,iBAAA;ATgVJ;;AS9UE;EACE,iBAAA;EACA,kBAAA;ATiVJ;;AS/UE;EACE,gBAAA;EACA,mBAAA;ATkVJ;;AS/UE;EACE,WAAA;ATkVJ;;AShVE;EACE,eAAA;ATmVJ;;ASjVE;EACE,iBAAA;AToVJ;;ASlVE;EACE,kBAAA;ATqVJ;;ASnVE;EACE,gBAAA;ATsVJ;;ASpVE;EACE,gBAAA;EACA,iBAAA;ATuVJ;;ASrVE;EACE,eAAA;EACA,kBAAA;ATwVJ;;ASrYE;EACE,aAAA;ATwYJ;;AStYE;EACE,iBAAA;ATyYJ;;ASvYE;EACE,mBAAA;AT0YJ;;ASxYE;EACE,oBAAA;AT2YJ;;ASzYE;EACE,kBAAA;AT4YJ;;AS1YE;EACE,kBAAA;EACA,mBAAA;AT6YJ;;AS3YE;EACE,iBAAA;EACA,oBAAA;AT8YJ;;AS3YE;EACE,YAAA;AT8YJ;;AS5YE;EACE,gBAAA;AT+YJ;;AS7YE;EACE,kBAAA;ATgZJ;;AS9YE;EACE,mBAAA;ATiZJ;;AS/YE;EACE,iBAAA;ATkZJ;;AShZE;EACE,iBAAA;EACA,kBAAA;ATmZJ;;ASjZE;EACE,gBAAA;EACA,mBAAA;AToZJ;;ASjcE;EACE,aAAA;ATocJ;;ASlcE;EACE,iBAAA;ATqcJ;;ASncE;EACE,mBAAA;ATscJ;;ASpcE;EACE,oBAAA;ATucJ;;ASrcE;EACE,kBAAA;ATwcJ;;AStcE;EACE,kBAAA;EACA,mBAAA;ATycJ;;ASvcE;EACE,iBAAA;EACA,oBAAA;AT0cJ;;ASvcE;EACE,YAAA;AT0cJ;;ASxcE;EACE,gBAAA;AT2cJ;;ASzcE;EACE,kBAAA;AT4cJ;;AS1cE;EACE,mBAAA;AT6cJ;;AS3cE;EACE,iBAAA;AT8cJ;;AS5cE;EACE,iBAAA;EACA,kBAAA;AT+cJ;;AS7cE;EACE,gBAAA;EACA,mBAAA;ATgdJ;;AS7fE;EACE,aAAA;ATggBJ;;AS9fE;EACE,iBAAA;ATigBJ;;AS/fE;EACE,mBAAA;ATkgBJ;;AShgBE;EACE,oBAAA;ATmgBJ;;ASjgBE;EACE,kBAAA;ATogBJ;;ASlgBE;EACE,kBAAA;EACA,mBAAA;ATqgBJ;;ASngBE;EACE,iBAAA;EACA,oBAAA;ATsgBJ;;ASngBE;EACE,YAAA;ATsgBJ;;ASpgBE;EACE,gBAAA;ATugBJ;;ASrgBE;EACE,kBAAA;ATwgBJ;;AStgBE;EACE,mBAAA;ATygBJ;;ASvgBE;EACE,iBAAA;AT0gBJ;;ASxgBE;EACE,iBAAA;EACA,kBAAA;AT2gBJ;;ASzgBE;EACE,gBAAA;EACA,mBAAA;AT4gBJ;;ASzjBE;EACE,aAAA;AT4jBJ;;AS1jBE;EACE,iBAAA;AT6jBJ;;AS3jBE;EACE,mBAAA;AT8jBJ;;AS5jBE;EACE,oBAAA;AT+jBJ;;AS7jBE;EACE,kBAAA;ATgkBJ;;AS9jBE;EACE,kBAAA;EACA,mBAAA;ATikBJ;;AS/jBE;EACE,iBAAA;EACA,oBAAA;ATkkBJ;;AS/jBE;EACE,YAAA;ATkkBJ;;AShkBE;EACE,gBAAA;ATmkBJ;;ASjkBE;EACE,kBAAA;ATokBJ;;ASlkBE;EACE,mBAAA;ATqkBJ;;ASnkBE;EACE,iBAAA;ATskBJ;;ASpkBE;EACE,iBAAA;EACA,kBAAA;ATukBJ;;ASrkBE;EACE,gBAAA;EACA,mBAAA;ATwkBJ;;ASrnBE;EACE,aAAA;ATwnBJ;;AStnBE;EACE,iBAAA;ATynBJ;;ASvnBE;EACE,mBAAA;AT0nBJ;;ASxnBE;EACE,oBAAA;AT2nBJ;;ASznBE;EACE,kBAAA;AT4nBJ;;AS1nBE;EACE,kBAAA;EACA,mBAAA;AT6nBJ;;AS3nBE;EACE,iBAAA;EACA,oBAAA;AT8nBJ;;AS3nBE;EACE,YAAA;AT8nBJ;;AS5nBE;EACE,gBAAA;AT+nBJ;;AS7nBE;EACE,kBAAA;ATgoBJ;;AS9nBE;EACE,mBAAA;ATioBJ;;AS/nBE;EACE,iBAAA;ATkoBJ;;AShoBE;EACE,iBAAA;EACA,kBAAA;ATmoBJ;;ASjoBE;EACE,gBAAA;EACA,mBAAA;ATooBJ;;ASjrBE;EACE,aAAA;ATorBJ;;ASlrBE;EACE,iBAAA;ATqrBJ;;ASnrBE;EACE,mBAAA;ATsrBJ;;ASprBE;EACE,oBAAA;ATurBJ;;ASrrBE;EACE,kBAAA;ATwrBJ;;AStrBE;EACE,kBAAA;EACA,mBAAA;ATyrBJ;;ASvrBE;EACE,iBAAA;EACA,oBAAA;AT0rBJ;;ASvrBE;EACE,YAAA;AT0rBJ;;ASxrBE;EACE,gBAAA;AT2rBJ;;ASzrBE;EACE,kBAAA;AT4rBJ;;AS1rBE;EACE,mBAAA;AT6rBJ;;AS3rBE;EACE,iBAAA;AT8rBJ;;AS5rBE;EACE,iBAAA;EACA,kBAAA;AT+rBJ;;AS7rBE;EACE,gBAAA;EACA,mBAAA;ATgsBJ;;AS7uBE;EACE,aAAA;ATgvBJ;;AS9uBE;EACE,iBAAA;ATivBJ;;AS/uBE;EACE,mBAAA;ATkvBJ;;AShvBE;EACE,oBAAA;ATmvBJ;;ASjvBE;EACE,kBAAA;ATovBJ;;ASlvBE;EACE,kBAAA;EACA,mBAAA;ATqvBJ;;ASnvBE;EACE,iBAAA;EACA,oBAAA;ATsvBJ;;ASnvBE;EACE,YAAA;ATsvBJ;;ASpvBE;EACE,gBAAA;ATuvBJ;;ASrvBE;EACE,kBAAA;ATwvBJ;;AStvBE;EACE,mBAAA;ATyvBJ;;ASvvBE;EACE,iBAAA;AT0vBJ;;ASxvBE;EACE,iBAAA;EACA,kBAAA;AT2vBJ;;ASzvBE;EACE,gBAAA;EACA,mBAAA;AT4vBJ;;ASzyBE;EACE,aAAA;AT4yBJ;;AS1yBE;EACE,iBAAA;AT6yBJ;;AS3yBE;EACE,mBAAA;AT8yBJ;;AS5yBE;EACE,oBAAA;AT+yBJ;;AS7yBE;EACE,kBAAA;ATgzBJ;;AS9yBE;EACE,kBAAA;EACA,mBAAA;ATizBJ;;AS/yBE;EACE,iBAAA;EACA,oBAAA;ATkzBJ;;AS/yBE;EACE,YAAA;ATkzBJ;;AShzBE;EACE,gBAAA;ATmzBJ;;ASjzBE;EACE,kBAAA;ATozBJ;;ASlzBE;EACE,mBAAA;ATqzBJ;;ASnzBE;EACE,iBAAA;ATszBJ;;ASpzBE;EACE,iBAAA;EACA,kBAAA;ATuzBJ;;ASrzBE;EACE,gBAAA;EACA,mBAAA;ATwzBJ;;ASr2BE;EACE,aAAA;ATw2BJ;;ASt2BE;EACE,iBAAA;ATy2BJ;;ASv2BE;EACE,mBAAA;AT02BJ;;ASx2BE;EACE,oBAAA;AT22BJ;;ASz2BE;EACE,kBAAA;AT42BJ;;AS12BE;EACE,kBAAA;EACA,mBAAA;AT62BJ;;AS32BE;EACE,iBAAA;EACA,oBAAA;AT82BJ;;AS32BE;EACE,YAAA;AT82BJ;;AS52BE;EACE,gBAAA;AT+2BJ;;AS72BE;EACE,kBAAA;ATg3BJ;;AS92BE;EACE,mBAAA;ATi3BJ;;AS/2BE;EACE,iBAAA;ATk3BJ;;ASh3BE;EACE,iBAAA;EACA,kBAAA;ATm3BJ;;ASj3BE;EACE,gBAAA;EACA,mBAAA;ATo3BJ;;AUx6BA;EACE;;;;;cAAA;EAMA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA,wDAAA;AVu6BF;;AUp6BA,8EAAA;AACA,2DAAA;AACA,wCAAA;AACA,uCAAA;AACA;EACE,wCAAA;AVu6BF;;AUp6BA,iDAAA;AACA;EACE,wCAAA;AVu6BF;;AUp6BA;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;AVu6BF;AUr6BE;EACE,aAAA;AVu6BJ;;AUn6BA,oBAAA;AACA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AVs6BF;;AUn6BA;EACE,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wHAAA;AVs6BF;;AUl6BA;EACE,oCAAA;EACA,yBAAA;AVq6BF;;AUl6BA;EACE,iCAAA;EACA,oCAAA;EACA,0HAAA;AVq6BF;;AUj6BA;EACE,kCAAA;AVo6BF;;AUj6BA;EACE,6BAAA;AVo6BF;;AUj6BA;EACE,kCAAA;AVo6BF;;AUj6BA;;EAEE,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,iCAAA;EACA,qBAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,+CAAA;EACA,wHAAA;AVo6BF;;AUh6BA,2BAAA;AAEA;EACE,SAAA;AVk6BF;;AU/5BA;EACE,WAAA;EACA,2BAAA;AVk6BF;AUh6BE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;AVk6BJ;AU/5BE;EACE,uBAAA;AVi6BJ;AU95BE;EACE,kBAAA;AVg6BJ;;AU55BA;EACE,WAAA;EACA,2BAAA;AV+5BF;;AU55BA;EACE,WAAA;EACA,gBAAA;AV+5BF;AU75BE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,yBAAA;AV+5BJ;AU55BE;EACE,uBAAA;AV85BJ;AU35BE;EACE,kBAAA;AV65BJ;;AUz5BA;EACE,WAAA;EACA,gBAAA;AV45BF;AU15BE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,uBAAA;AV45BJ;AUz5BE;EACE,uBAAA;AV25BJ;AUx5BE;EACE,kBAAA;AV05BJ;;AUt5BA;EACE,WAAA;EACA,gBAAA;AVy5BF;AUv5BE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;AVy5BJ;AUt5BE;EACE,uBAAA;AVw5BJ;AUr5BE;EACE,kBAAA;AVu5BJ;;AUn5BA;EACE,aAAA;AVs5BF;;AUn5BA;EACE,2BAAA;AVs5BF;AUn5BI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;AVq5BN;AUl5BI;EACE,iBAAA;EACA,eAAA;AVo5BN;AUj5BI;EACE,mBAAA;AVm5BN;AUh5BI;EACE,2CAAA;AVk5BN;;AU74BA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AVg5BF;;AU74BA;EACE,oBAAA;EACA,mBAAA;AVg5BF;AU94BE;EACE,YAAA;EACA,WAAA;AVg5BJ;;AU34BI;EADF;IAEI,gBAAA;IACA,0BAAA;IACA,qBAAA;IACA,YAAA;EV+4BJ;AACF;;AU54BA;EACE,4BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AV+4BF;AU74BE;EAXF;IAYI,gBAAA;IACA,0BAAA;IACA,UAAA;IACA,YAAA;EVg5BF;AACF;AU94BE;EACE,8BAAA;AVg5BJ;;AU54BA;EACE,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AV+4BF;AU74BE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EVg5BF;AACF;AU94BE;EACE,8BAAA;AVg5BJ;;AU54BA;EACE,8BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AV+4BF;AU74BE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EVg5BF;AACF;;AU74BA;;CAAA;AAGA;EACE,gBAAA;EACA,kBAAA;AVg5BF;;AU74BA;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;AVg5BF;;AU94BA;EACE,mDAAA;EACA,4CAAA;AVi5BF;;AU94BA;EACE,sCAAA;EACA,kBAAA;EACA,yCAAA;AVi5BF;;AU/4BA;EACE,uBAAA;EACA,kBAAA;EACA,yCAAA;AVk5BF;;AUh5BA;EACE,kCAAA;EACA,kBAAA;EACA,kCAAA;AVm5BF;;AUj5BA;EACE,2BAAA;AVo5BF;;AUj5BE;EACE,YAAA;AVo5BJ;AUl5BE;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,8BAAA;AVo5BJ;AUj5BI;EACE,yBAAA;EACA,oCAAA;AVm5BN;AU/4BE;EACE,uBAAA;AVi5BJ;AU/4BE;EACE,uBAAA;AVi5BJ;AU/4BE;EACE,uBAAA;AVi5BJ;;AU74BA;EACE;IACE,4BAAA;IACA,eAAA;EVg5BF;EU74BA;IACE,2BAAA;IACA,4BAAA;IACA,eAAA;EV+4BF;EU54BA;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;EV84BF;EU54BA;IACE,WAAA;IACA,gBAAA;IACA,4BAAA;IACA,2BAAA;EV84BF;EU54BA;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;EV84BF;AACF;AU34BA;EACE;IACE,kBAAA;EV64BF;EU34BA;IACE,iBAAA;IACA,2BAAA;IACA,eAAA;EV64BF;EU14BA;IACE,kBAAA;IACA,0BAAA;EV44BF;EU14BA;IACE,0BAAA;IACA,0BAAA;IACA,2BAAA;EV44BF;EU14BE;IACF,kBAAA;IACE,0BAAA;EV44BF;AACF;AUz4BA;EACE;IACE,UAAA;EV24BF;AACF;AUx4BA;EACE,wCAAA;AV04BF;;AUv4BA;EACE;IACE,iBAAA;IACA,8CAAA;EV04BF;AACF;AUv4BA;EACE,kCAAA;EACA,oBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;AVy4BF;AUv4BE;EACE,sBAAA;AVy4BJ;;AUr4BA;EACE,wBAAA;AVw4BF;;AUt4BA;EACE,qBAAA,EAAA,wCAAA;AVy4BF;;AUv4BA;EACE,iBAAA;EACA,iBAAA;EACA,yBAAA;AV04BF;AUx4BE;EACE,UAAA;EACA,aAAA;EACA,YAAA;EAEA,8BAAA;EACA,aAAA;AVy4BJ;AUv4BI;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;AVy4BN;AUt4BI;;EAEE,eAAA;EACA,mBAAA;EACA,cAAA;AVw4BN;AUt4BI;EApBF;IAqBI,WAAA;IACA,cAAA;EVy4BJ;AACF;AUt4BE;EACE,iBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AVw4BJ;AUt4BI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AVw4BN;AUp4BE;EACE,iBAAA;EACA,uBAAA;AVs4BJ;AUn4BI;EADF;IAEI,eAAA;EVs4BJ;AACF;AUn4BE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AVq4BJ;AUl4BE;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AVo4BJ;AUl4BI;EACE,iBAAA;AVo4BN;;AU/3BA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AVk4BF;;AU/3BA;EACE,kCAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AVk4BF;;AU/3BA;EACE,qBAAA;AVk4BF;;AU/3BA;EACE,kCAAA;EACA,YAAA;AVk4BF;;AU/3BA;EACE,kCAAA;EACA,YAAA;AVk4BF;;AUh4BA;EAEE,cAAA;EACA,yBAAA;EACA,mBAAA;AVk4BF;;AU93BA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AVi4BF;;AU/3BA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AVk4BF;AUh4BE;EACE,WAAA;AVk4BJ;AU/3BE;EACE;IACE,aAAA;EVi4BJ;AACF;;AU73BA;EACE,aAAA;EACA,mBAAA;AVg4BF;AU93BE;EACE,WAAA;AVg4BJ;AU73BE;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;AV+3BJ;AU53BE;EACE,uBAAA;AV83BJ;AU33BE;EACE,uBAAA;AV63BJ;;AUz3BA;;EAEE,mCAAA;EACA,6BAAA;EACA,yCAAA;EACA,4DAAA;EACA,0DAAA;EACA,0DAAA;AV43BF;;AUz3BA;EACE,uBAAA;AV43BF;;AUz3BA;EACE,aAAA;EACA,eAAA;AV43BF;AU13BE;EACE,kBAAA;EACA,iBAAA;EACA,2CAAA;EACA,WAAA;AV43BJ;;AUx3BA;EACE,gBAAA;EACA,kBAAA;AV23BF;;AUv3BA;EACE,iDAAA;EACA,oBAAA;EACA,wBAAA;EACA,uBAAA;AV03BF;;AUt3BE;EACE,gBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,sBAAA;AVy3BJ;;AUp3BE;EACE,mCAAA;AVu3BJ;AUp3BE;EACE,wBAAA;EACA,kBAAA;AVs3BJ;;AUj3BE;EACE,kCAAA;AVo3BJ;AUj3BE;EACE,uBAAA;EACA,kBAAA;AVm3BJ;;AU/2BA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AVk3BF;AUh3BE;EACE,sCAAA;EACA,+CAAA;AVk3BJ;;AU92BA;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AVi3BF;;AU92BA,oCAAA;AACA;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AVi3BF;;AU92BA;EAEE,qBAAA;AVg3BF;;AUz2BA;EAEE,cAAA;AV22BF;;AUx2BA;EACM,2BAAA;AV22BN;;AUz2BA;EACE,2BAAA;AV42BF;;AU12BA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AV62BF;;AU12BA;EACE,aAAA;EACA,iBAAA;AV62BF;;AU12BA;EACE,mCAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AV62BF;AU32BE;EACE,kBAAA;AV62BJ;;AUz2BA;EACE,kBAAA;EACA,kBAAA;AV42BF;;AU12BA;EACE,YAAA;EAEA,wCAAA;EACA,yBAAA;EACA,kBAAA;AV42BF;AU12BE;EACE,gBAAA;AV42BJ;AU12BE;EACE,WAAA;AV42BJ;;AUx2BA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;AV22BF;;AUx2BA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AV22BF;;AUx2BA;EACE,sBAAA;EACA,YAAA;AV22BF;;AUx2BA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AV22BF;;AUz2BA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;AV42BF;;AU12BA;EACE,iCAAA;AV62BF;;AU32BA;EACE,sBAAA;AV82BF;;AU52BA;EACE,iDAAA;EACA,mDAAA;AV+2BF;;AU52BE;EACE,8BAAA;AV+2BJ;;AU32BE;EACE,8BAAA;AV82BJ;;AU32BA;EACE,uBAAA;AV82BF;;AU52BA;EAEE,kCAAA;EACA,YAAA;EACA,kCAAA;EACA,6BAAA;AV82BF;;AU52BA;EACE,6BAAA;EACA,kBAAA;AV+2BF;;AU72BA;EACE,oCAAA;AVg3BF;;AU92BA;EACE,kCAAA;AVi3BF;;AU92BE;EADF;IAEI,WAAA;EVk3BF;AACF;;AU/2BA;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AVk3BF;;AU92BE;EACE,qBAAA;AVi3BJ;AUt2BA;EACI,eAAA;EACI,oBAAA;EACJ,aAAA;AVw2BJ;;AUt2BA;EACI,eAAA;EACE,oBAAA;EACF,aAAA;AVy2BJ;;AUt2BA;EACE,2BAAA;AVy2BF;;AUr2BE;EADF;IAEI,wBAAA;EVy2BF;AACF;;AUv2BA;EACE,4CAAA;EACA,gDAAA,EAAA,iBAAA;EACA,sDAAA,EAAA,mBAAA;EACA,8CAAA;AV02BF;;AUv2BA;EAAO,iBAAA;AV22BP;;AU12BA;EAAO,uBAAA;AV82BP;;AU72BA;EAAO,sBAAA;AVi3BP;;AUh3BA;EAAO,oBAAA;AVo3BP;;AUn3BA;EAAO,sBAAA;AVu3BP;;AUt3BA;EAAO,oBAAA;AV03BP;;AUv3BA;EAAQ,wBAAA;AV23BR;;AU13BA;EAAQ,8BAAA;AV83BR;;AU73BA;EAAQ,6BAAA;AVi4BR;;AUh4BA;EAAQ,2BAAA;AVo4BR;;AUn4BA;EAAQ,6BAAA;AVu4BR;;AUt4BA;EAAQ,2BAAA;AV04BR;;AUv4BA;EAAQ,qBAAA;AV24BR;;AU14BA;EAAQ,2BAAA;AV84BR;;AU74BA;EAAQ,0BAAA;AVi5BR;;AUh5BA;EAAQ,wBAAA;AVo5BR;;AUn5BA;EAAQ,0BAAA;AVu5BR;;AUt5BA;EAAQ,wBAAA;AV05BR;;AUz5BA;EACE,YAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;AV45BF;;AUz5BA;EAAS,mBAAA;EAAqB,oBAAA;AV85B9B;;AU75BA;EAAS,oBAAA;EAAsB,qBAAA;AVk6B/B;;AUj6BA;EAAS,aAAA;EAAe,cAAA;AVs6BxB;;AUr6BA;EAAS,oBAAA;EAAsB,qBAAA;AV06B/B;;AUz6BA;EAAS,oBAAA;EAAsB,qBAAA;AV86B/B;;AU76BA;EAAS,aAAA;EAAe,cAAA;AVk7BxB;;AUj7BA;EAAS,oBAAA;EAAsB,qBAAA;AVs7B/B;;AUr7BA;EAAS,oBAAA;EAAsB,qBAAA;AV07B/B;;AUz7BA;EAAS,aAAA;EAAe,cAAA;AV87BxB;;AU77BA;EAAU,oBAAA;EAAsB,qBAAA;AVk8BhC;;AUj8BA;EAAU,oBAAA;EAAsB,qBAAA;AVs8BhC;;AUr8BA;EAAU,aAAA;EAAe,cAAA;AV08BzB;;AUx8BA,wBAAA;AACA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EV68BjC;EU58BA;IAAY,oBAAA;IAAsB,qBAAA;EVg9BlC;EU/8BA;IAAY,aAAA;IAAe,cAAA;EVm9B3B;EUl9BA;IAAY,oBAAA;IAAsB,qBAAA;EVs9BlC;EUr9BA;IAAY,oBAAA;IAAsB,qBAAA;EVy9BlC;EUx9BA;IAAY,aAAA;IAAe,cAAA;EV49B3B;EU39BA;IAAY,oBAAA;IAAsB,qBAAA;EV+9BlC;EU99BA;IAAY,oBAAA;IAAsB,qBAAA;EVk+BlC;EUj+BA;IAAY,aAAA;IAAe,cAAA;EVq+B3B;EUp+BA;IAAa,oBAAA;IAAsB,qBAAA;EVw+BnC;EUv+BA;IAAa,oBAAA;IAAsB,qBAAA;EV2+BnC;EU1+BA;IAAa,aAAA;IAAe,cAAA;EV8+B5B;AACF;AU5+BA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVg/BjC;EU/+BA;IAAY,oBAAA;IAAsB,qBAAA;EVm/BlC;EUl/BA;IAAY,aAAA;IAAe,cAAA;EVs/B3B;EUr/BA;IAAY,oBAAA;IAAsB,qBAAA;EVy/BlC;EUx/BA;IAAY,oBAAA;IAAsB,qBAAA;EV4/BlC;EU3/BA;IAAY,aAAA;IAAe,cAAA;EV+/B3B;EU9/BA;IAAY,oBAAA;IAAsB,qBAAA;EVkgClC;EUjgCA;IAAY,oBAAA;IAAsB,qBAAA;EVqgClC;EUpgCA;IAAY,aAAA;IAAe,cAAA;EVwgC3B;EUvgCA;IAAa,oBAAA;IAAsB,qBAAA;EV2gCnC;EU1gCA;IAAa,oBAAA;IAAsB,qBAAA;EV8gCnC;EU7gCA;IAAa,cAAA;IAAgB,eAAA;EVihC7B;AACF;AU/gCA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVmhCjC;EUlhCA;IAAY,oBAAA;IAAsB,qBAAA;EVshClC;EUrhCA;IAAY,aAAA;IAAe,cAAA;EVyhC3B;EUxhCA;IAAY,oBAAA;IAAsB,qBAAA;EV4hClC;EU3hCA;IAAY,oBAAA;IAAsB,qBAAA;EV+hClC;EU9hCA;IAAY,aAAA;IAAe,cAAA;EVkiC3B;EUjiCA;IAAY,oBAAA;IAAsB,qBAAA;EVqiClC;EUpiCA;IAAY,oBAAA;IAAsB,qBAAA;EVwiClC;EUviCA;IAAY,aAAA;IAAe,cAAA;EV2iC3B;EU1iCA;IAAa,oBAAA;IAAsB,qBAAA;EV8iCnC;EU7iCA;IAAa,oBAAA;IAAsB,qBAAA;EVijCnC;EUhjCA;IAAa,aAAA;IAAe,cAAA;EVojC5B;AACF;AUljCA,6BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVsjCjC;EUrjCA;IAAY,oBAAA;IAAsB,qBAAA;EVyjClC;EUxjCA;IAAY,aAAA;IAAe,cAAA;EV4jC3B;EU3jCA;IAAY,oBAAA;IAAsB,qBAAA;EV+jClC;EU9jCA;IAAY,oBAAA;IAAsB,qBAAA;EVkkClC;EUjkCA;IAAY,aAAA;IAAe,cAAA;EVqkC3B;EUpkCA;IAAY,oBAAA;IAAsB,qBAAA;EVwkClC;EUvkCA;IAAY,oBAAA;IAAsB,qBAAA;EV2kClC;EU1kCA;IAAY,aAAA;IAAe,cAAA;EV8kC3B;EU7kCA;IAAa,oBAAA;IAAsB,qBAAA;EVilCnC;EUhlCA;IAAa,oBAAA;IAAsB,qBAAA;EVolCnC;EUnlCA;IAAa,aAAA;IAAe,cAAA;EVulC5B;AACF;AUrlCA,6BAAA,QAAA;EACE;IAAa,mBAAA;IAAqB,oBAAA;EVylClC;EUxlCA;IAAa,oBAAA;IAAsB,qBAAA;EV4lCnC;EU3lCA;IAAa,aAAA;IAAe,cAAA;EV+lC5B;EU9lCA;IAAa,oBAAA;IAAsB,qBAAA;EVkmCnC;EUjmCA;IAAa,oBAAA;IAAsB,qBAAA;EVqmCnC;EUpmCA;IAAa,aAAA;IAAe,cAAA;EVwmC5B;EUvmCA;IAAa,oBAAA;IAAsB,qBAAA;EV2mCnC;EU1mCA;IAAa,oBAAA;IAAsB,qBAAA;EV8mCnC;EU7mCA;IAAa,aAAA;IAAe,cAAA;EVinC5B;EUhnCA;IAAc,oBAAA;IAAsB,qBAAA;EVonCpC;EUnnCA;IAAc,oBAAA;IAAsB,qBAAA;EVunCpC;EUtnCA;IAAc,aAAA;IAAe,cAAA;EV0nC7B;AACF;AUznCA;EACE,0BAAA;AV2nCF;;AUznCA;EACE,iBAAA;AV4nCF;;AU1nCA;EACI,4CAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;AV6nCJ;;AU1nCA;EACI,uBAAA;AV6nCJ;;AU1nCA;EACI,aAAA;AV6nCJ;;AU1nCA;EAEI,gCAAA;EACA,oCAAA;AV4nCJ;;AAtsEA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAysEF;;AAtsEA;EACE,+CAAA;EACA,YAAA;EACA,+CAAA;EACA,mBAAA;AAysEF;;AAtsEA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;AAysEF;AAvsEE;EACE,sBAAA;AAysEJ;AAtsEE;EAEE,WAAA;EACA,aAAA;EACA,sBAAA;AAusEJ;AArsEI;EANF;IAOI,UAAA;EAwsEJ;AACF;AAtsEI;EACE,sBAAA;AAwsEN;AAlsEM;EACE,eAAA;EAEA,kBAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;AAmsER;AAjsEQ;EAVF;IAWI,gBAAA;EAosER;AACF;AA/rEE;EA3CF;IA4CI,UAAA;EAksEF;AACF;;AAhsEA;EACE,8BAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;AAmsEF;AAlsEE;EACE,aAAA;EACA,iBAAA;EACA,4CAAA;EACA,gBAAA;EACA,uBAAA;AAosEJ;AAnsEI;EACE,WAAA;AAqsEN;;AAjsEA;EACE,YAAA;AAosEF;;AAjsEA;EACE,wBAAA;AAosEF;;AAjsEA;EACE,mCAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AAosEF;AAlsEE;EACE,OAAA;AAosEJ;AAjsEE;EACE,mBAAA;AAmsEJ;;AA/rEA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;AAksEF;;AA9rEE;EACE,mBAAA;AAisEJ;AA/rEE;EAJF;IAKI,UAAA;EAksEF;AACF;;AA/rEA;EACE;IACE,aAAA;IACA,mBAAA;IACA,WAAA;IACA,8BAAA;EAksEF;EAhsEE;IACE,qBAAA;EAksEJ;EA/rEE;IACE,UAAA;EAisEJ;EA/rEI;IACE,qBAAA;EAisEN;EA5rEI;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,8BAAA;EA8rEN;EA5rEM;IACE,YAAA;IACA,UAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EA8rER;AACF;AAxrEA;EACE,WAAA;EACA,gBAAA;EACA,6BAAA;EACA,cAAA;AA0rEF;;AAvrEA;EACE,SAAA;AA0rEF;;AAvrEA;EACE,sBAAA;AA0rEF;;AAvrEA;EACE,mBAAA;AA0rEF;;AAprEE;EACE,WAAA;AAurEJ;AAprEE;EACE,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;AAsrEJ;;AAjrEA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AAorEF;AAlrEE;EACE,eAAA;EACA,mBAAA;AAorEJ;;AC93EE;EACE,gBAAA;EAIA,kBAAA;AD83EJ;ACv3EI;EACE,wBAAA;ADy3EN;;ACr3EE;EACE,iBAAA;ADw3EJ;;ACr3EE;EACE,kBAAA;EACA,kBAAA;EACA,oBAAA;EAEA,6DAAA;EAIA,2BAAA;ADo3EJ;AEr2EI;EDXE,aAAA;ADm3EN;;AEv5EE;EACE,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EAIA,mBAAA;EAGA,UAAA;EAGA,wBAAA;EACA,qBAAA;EAMA,OAAA;AF84EJ;AE54EI;EACE,UAAA;EACA,QAAA;AF84EN;;AG95EE;EAEE,oBAAA;EAGA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AH85EJ;;AG15EE;EACE,eAAA;EACA,aA3BwB;AHw7E5B;AG35EI;EAGE,aAAA;AH25EN;;AGn5EE;EACE,aAAA;EACA,kBAAA;EACA,aA1Cc;AHg8ElB;;AGl5EE;EAGE,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,aApDc;EAwDd,aAAA;EACA,eAAA;EACA,gBAAA;AHg5EJ;;AG74EE;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EAEA,aApEuB;EAqEvB,oBAAA;EACA,wCAAA;EACA,0DAAA;EACA,UAAA;AH84EJ;AG54EI;EACE,UAAA;AH84EN;AGz4EM;EAGE,YAAA;AHy4ER;;AGp4EE;EACE,+BAtFqB;AH69EzB;;AGp4EE;EAEE,qDAAA;EACA,kBAAA;EACA,UAAA;AHs4EJ;AGh4EI;EACE,UAAA;EACA,mBAAA;AHk4EN;;AG93EE;EACE,gBAAA;AHi4EJ;;AG53EE;EACE,kBAAA;EACA,aArHc;EA0Hd,aAAA;EAIA,sBAAA;EAGA,cAAA;EACA,eAAA;AHs3EJ;;AGl3EE;EACE,eAAA;EAKA,WAAA;EAKA,kBAAA;AH62EJ;;AI9/EE;EACE,YAAA;AJigFJ;;AI3/EE;EAyCA,yBAAA;EACA,kCAAA;EAxCE,uBAAA;EACA,2BAAA;AJ+/EJ;;AIt/EE;EA6BA,yBAAA;EACA,kCAAA;EA5BE,oBAAA;AJ0/EJ;;AIh/EE,2CAAA,IAAA,EAAA;AACA,yCAAA,IAAA,EAAA;AAEA;EAEE,+CAAA;AJi/EJ;;AI9+EE;EAEE,6CAAA;AJg/EJ;;AK/gFE;EACE,kBAAA;ALkhFJ;AKhhFI;ECfF,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EDaI,sBAAA;EACA,oBAAA;EACA,iDAAA;EACA,wJAAA;EAYA,4DAAA;AL2gFN;AKngFI;EACE,WAAA;ALqgFN;;AE19EM;EG7BA,oCAAA;AL2/EN;;AKtiFE;EACE,kBAAA;ALyiFJ;AKviFI;ECfF,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EDaI,sBAAA;EACA,oBAAA;EACA,qDAAA;EACA,oKAAA;EAYA,gEAAA;ALkiFN;AK1hFI;EACE,WAAA;AL4hFN;;AEj/EM;EG7BA,wCAAA;ALkhFN;;AO3kFA;;;;;CAAA;ACEA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ARklFF;;AQ/kFA;;;;;;EAME,qCAAA;EACA,gBAAA;ARklFF;;AQ/kFA;EACE,eAAA;EACA,iBAAA;ARklFF;;AQ/kFA;EACE,eAAA;EACA,iBAAA;ARklFF;;AQ/kFA;EACE,eAAA;EACA,iBAAA;ARklFF;;AQ/kFA;EACE,eAAA;EACA,iBAAA;ARklFF;;AQ/kFA;EACE,eAAA;EACA,iBAAA;ARklFF;;AQ/kFA;EACE,eAAA;EACA,iBAAA;ARklFF;;AQ/kFA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;ARklFF;;AQ/kFA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;ARklFF;;AQ/kFA;EACE,gBAAA;EACA,eAAA;ARklFF;;AOppFA;;;;;CAAA;AEeE;EACE,YAAA;AT8oFJ;;AS5oFE;EACE,gBAAA;AT+oFJ;;AS7oFE;EACE,kBAAA;ATgpFJ;;AS9oFE;EACE,mBAAA;ATipFJ;;AS/oFE;EACE,iBAAA;ATkpFJ;;AShpFE;EACE,iBAAA;EACA,kBAAA;ATmpFJ;;ASjpFE;EACE,gBAAA;EACA,mBAAA;ATopFJ;;ASjpFE;EACE,WAAA;ATopFJ;;ASlpFE;EACE,eAAA;ATqpFJ;;ASnpFE;EACE,iBAAA;ATspFJ;;ASppFE;EACE,kBAAA;ATupFJ;;ASrpFE;EACE,gBAAA;ATwpFJ;;AStpFE;EACE,gBAAA;EACA,iBAAA;ATypFJ;;ASvpFE;EACE,eAAA;EACA,kBAAA;AT0pFJ;;ASvsFE;EACE,YAAA;AT0sFJ;;ASxsFE;EACE,gBAAA;AT2sFJ;;ASzsFE;EACE,kBAAA;AT4sFJ;;AS1sFE;EACE,mBAAA;AT6sFJ;;AS3sFE;EACE,iBAAA;AT8sFJ;;AS5sFE;EACE,iBAAA;EACA,kBAAA;AT+sFJ;;AS7sFE;EACE,gBAAA;EACA,mBAAA;ATgtFJ;;AS7sFE;EACE,WAAA;ATgtFJ;;AS9sFE;EACE,eAAA;ATitFJ;;AS/sFE;EACE,iBAAA;ATktFJ;;AShtFE;EACE,kBAAA;ATmtFJ;;ASjtFE;EACE,gBAAA;ATotFJ;;ASltFE;EACE,gBAAA;EACA,iBAAA;ATqtFJ;;ASntFE;EACE,eAAA;EACA,kBAAA;ATstFJ;;ASnwFE;EACE,aAAA;ATswFJ;;ASpwFE;EACE,iBAAA;ATuwFJ;;ASrwFE;EACE,mBAAA;ATwwFJ;;AStwFE;EACE,oBAAA;ATywFJ;;ASvwFE;EACE,kBAAA;AT0wFJ;;ASxwFE;EACE,kBAAA;EACA,mBAAA;AT2wFJ;;ASzwFE;EACE,iBAAA;EACA,oBAAA;AT4wFJ;;ASzwFE;EACE,YAAA;AT4wFJ;;AS1wFE;EACE,gBAAA;AT6wFJ;;AS3wFE;EACE,kBAAA;AT8wFJ;;AS5wFE;EACE,mBAAA;AT+wFJ;;AS7wFE;EACE,iBAAA;ATgxFJ;;AS9wFE;EACE,iBAAA;EACA,kBAAA;ATixFJ;;AS/wFE;EACE,gBAAA;EACA,mBAAA;ATkxFJ;;AS/zFE;EACE,aAAA;ATk0FJ;;ASh0FE;EACE,iBAAA;ATm0FJ;;ASj0FE;EACE,mBAAA;ATo0FJ;;ASl0FE;EACE,oBAAA;ATq0FJ;;ASn0FE;EACE,kBAAA;ATs0FJ;;ASp0FE;EACE,kBAAA;EACA,mBAAA;ATu0FJ;;ASr0FE;EACE,iBAAA;EACA,oBAAA;ATw0FJ;;ASr0FE;EACE,YAAA;ATw0FJ;;ASt0FE;EACE,gBAAA;ATy0FJ;;ASv0FE;EACE,kBAAA;AT00FJ;;ASx0FE;EACE,mBAAA;AT20FJ;;ASz0FE;EACE,iBAAA;AT40FJ;;AS10FE;EACE,iBAAA;EACA,kBAAA;AT60FJ;;AS30FE;EACE,gBAAA;EACA,mBAAA;AT80FJ;;AS33FE;EACE,aAAA;AT83FJ;;AS53FE;EACE,iBAAA;AT+3FJ;;AS73FE;EACE,mBAAA;ATg4FJ;;AS93FE;EACE,oBAAA;ATi4FJ;;AS/3FE;EACE,kBAAA;ATk4FJ;;ASh4FE;EACE,kBAAA;EACA,mBAAA;ATm4FJ;;ASj4FE;EACE,iBAAA;EACA,oBAAA;ATo4FJ;;ASj4FE;EACE,YAAA;ATo4FJ;;ASl4FE;EACE,gBAAA;ATq4FJ;;ASn4FE;EACE,kBAAA;ATs4FJ;;ASp4FE;EACE,mBAAA;ATu4FJ;;ASr4FE;EACE,iBAAA;ATw4FJ;;ASt4FE;EACE,iBAAA;EACA,kBAAA;ATy4FJ;;ASv4FE;EACE,gBAAA;EACA,mBAAA;AT04FJ;;ASv7FE;EACE,aAAA;AT07FJ;;ASx7FE;EACE,iBAAA;AT27FJ;;ASz7FE;EACE,mBAAA;AT47FJ;;AS17FE;EACE,oBAAA;AT67FJ;;AS37FE;EACE,kBAAA;AT87FJ;;AS57FE;EACE,kBAAA;EACA,mBAAA;AT+7FJ;;AS77FE;EACE,iBAAA;EACA,oBAAA;ATg8FJ;;AS77FE;EACE,YAAA;ATg8FJ;;AS97FE;EACE,gBAAA;ATi8FJ;;AS/7FE;EACE,kBAAA;ATk8FJ;;ASh8FE;EACE,mBAAA;ATm8FJ;;ASj8FE;EACE,iBAAA;ATo8FJ;;ASl8FE;EACE,iBAAA;EACA,kBAAA;ATq8FJ;;ASn8FE;EACE,gBAAA;EACA,mBAAA;ATs8FJ;;ASn/FE;EACE,aAAA;ATs/FJ;;ASp/FE;EACE,iBAAA;ATu/FJ;;ASr/FE;EACE,mBAAA;ATw/FJ;;ASt/FE;EACE,oBAAA;ATy/FJ;;ASv/FE;EACE,kBAAA;AT0/FJ;;ASx/FE;EACE,kBAAA;EACA,mBAAA;AT2/FJ;;ASz/FE;EACE,iBAAA;EACA,oBAAA;AT4/FJ;;ASz/FE;EACE,YAAA;AT4/FJ;;AS1/FE;EACE,gBAAA;AT6/FJ;;AS3/FE;EACE,kBAAA;AT8/FJ;;AS5/FE;EACE,mBAAA;AT+/FJ;;AS7/FE;EACE,iBAAA;ATggGJ;;AS9/FE;EACE,iBAAA;EACA,kBAAA;ATigGJ;;AS//FE;EACE,gBAAA;EACA,mBAAA;ATkgGJ;;AS/iGE;EACE,aAAA;ATkjGJ;;AShjGE;EACE,iBAAA;ATmjGJ;;ASjjGE;EACE,mBAAA;ATojGJ;;ASljGE;EACE,oBAAA;ATqjGJ;;ASnjGE;EACE,kBAAA;ATsjGJ;;ASpjGE;EACE,kBAAA;EACA,mBAAA;ATujGJ;;ASrjGE;EACE,iBAAA;EACA,oBAAA;ATwjGJ;;ASrjGE;EACE,YAAA;ATwjGJ;;AStjGE;EACE,gBAAA;ATyjGJ;;ASvjGE;EACE,kBAAA;AT0jGJ;;ASxjGE;EACE,mBAAA;AT2jGJ;;ASzjGE;EACE,iBAAA;AT4jGJ;;AS1jGE;EACE,iBAAA;EACA,kBAAA;AT6jGJ;;AS3jGE;EACE,gBAAA;EACA,mBAAA;AT8jGJ;;AS3mGE;EACE,aAAA;AT8mGJ;;AS5mGE;EACE,iBAAA;AT+mGJ;;AS7mGE;EACE,mBAAA;ATgnGJ;;AS9mGE;EACE,oBAAA;ATinGJ;;AS/mGE;EACE,kBAAA;ATknGJ;;AShnGE;EACE,kBAAA;EACA,mBAAA;ATmnGJ;;ASjnGE;EACE,iBAAA;EACA,oBAAA;ATonGJ;;ASjnGE;EACE,YAAA;ATonGJ;;ASlnGE;EACE,gBAAA;ATqnGJ;;ASnnGE;EACE,kBAAA;ATsnGJ;;ASpnGE;EACE,mBAAA;ATunGJ;;ASrnGE;EACE,iBAAA;ATwnGJ;;AStnGE;EACE,iBAAA;EACA,kBAAA;ATynGJ;;ASvnGE;EACE,gBAAA;EACA,mBAAA;AT0nGJ;;ASvqGE;EACE,aAAA;AT0qGJ;;ASxqGE;EACE,iBAAA;AT2qGJ;;ASzqGE;EACE,mBAAA;AT4qGJ;;AS1qGE;EACE,oBAAA;AT6qGJ;;AS3qGE;EACE,kBAAA;AT8qGJ;;AS5qGE;EACE,kBAAA;EACA,mBAAA;AT+qGJ;;AS7qGE;EACE,iBAAA;EACA,oBAAA;ATgrGJ;;AS7qGE;EACE,YAAA;ATgrGJ;;AS9qGE;EACE,gBAAA;ATirGJ;;AS/qGE;EACE,kBAAA;ATkrGJ;;AShrGE;EACE,mBAAA;ATmrGJ;;ASjrGE;EACE,iBAAA;ATorGJ;;ASlrGE;EACE,iBAAA;EACA,kBAAA;ATqrGJ;;ASnrGE;EACE,gBAAA;EACA,mBAAA;ATsrGJ;;ASnuGE;EACE,aAAA;ATsuGJ;;ASpuGE;EACE,iBAAA;ATuuGJ;;ASruGE;EACE,mBAAA;ATwuGJ;;AStuGE;EACE,oBAAA;ATyuGJ;;ASvuGE;EACE,kBAAA;AT0uGJ;;ASxuGE;EACE,kBAAA;EACA,mBAAA;AT2uGJ;;ASzuGE;EACE,iBAAA;EACA,oBAAA;AT4uGJ;;ASzuGE;EACE,YAAA;AT4uGJ;;AS1uGE;EACE,gBAAA;AT6uGJ;;AS3uGE;EACE,kBAAA;AT8uGJ;;AS5uGE;EACE,mBAAA;AT+uGJ;;AS7uGE;EACE,iBAAA;ATgvGJ;;AS9uGE;EACE,iBAAA;EACA,kBAAA;ATivGJ;;AS/uGE;EACE,gBAAA;EACA,mBAAA;ATkvGJ;;AUtyGA;EACE;;;;;cAAA;EAMA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA,wDAAA;AVqyGF;;AUlyGA,8EAAA;AACA,2DAAA;AACA,wCAAA;AACA,uCAAA;AACA;EACE,wCAAA;AVqyGF;;AUlyGA,iDAAA;AACA;EACE,wCAAA;AVqyGF;;AUlyGA;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;AVqyGF;AUnyGE;EACE,aAAA;AVqyGJ;;AUjyGA,oBAAA;AACA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AVoyGF;;AUjyGA;EACE,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wHAAA;AVoyGF;;AUhyGA;EACE,oCAAA;EACA,yBAAA;AVmyGF;;AUhyGA;EACE,iCAAA;EACA,oCAAA;EACA,0HAAA;AVmyGF;;AU/xGA;EACE,kCAAA;AVkyGF;;AU/xGA;EACE,6BAAA;AVkyGF;;AU/xGA;EACE,kCAAA;AVkyGF;;AU/xGA;;EAEE,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,iCAAA;EACA,qBAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,+CAAA;EACA,wHAAA;AVkyGF;;AU9xGA,2BAAA;AAEA;EACE,SAAA;AVgyGF;;AU7xGA;EACE,WAAA;EACA,2BAAA;AVgyGF;AU9xGE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;AVgyGJ;AU7xGE;EACE,uBAAA;AV+xGJ;AU5xGE;EACE,kBAAA;AV8xGJ;;AU1xGA;EACE,WAAA;EACA,2BAAA;AV6xGF;;AU1xGA;EACE,WAAA;EACA,gBAAA;AV6xGF;AU3xGE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,yBAAA;AV6xGJ;AU1xGE;EACE,uBAAA;AV4xGJ;AUzxGE;EACE,kBAAA;AV2xGJ;;AUvxGA;EACE,WAAA;EACA,gBAAA;AV0xGF;AUxxGE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,uBAAA;AV0xGJ;AUvxGE;EACE,uBAAA;AVyxGJ;AUtxGE;EACE,kBAAA;AVwxGJ;;AUpxGA;EACE,WAAA;EACA,gBAAA;AVuxGF;AUrxGE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;AVuxGJ;AUpxGE;EACE,uBAAA;AVsxGJ;AUnxGE;EACE,kBAAA;AVqxGJ;;AUjxGA;EACE,aAAA;AVoxGF;;AUjxGA;EACE,2BAAA;AVoxGF;AUjxGI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;AVmxGN;AUhxGI;EACE,iBAAA;EACA,eAAA;AVkxGN;AU/wGI;EACE,mBAAA;AVixGN;AU9wGI;EACE,2CAAA;AVgxGN;;AU3wGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AV8wGF;;AU3wGA;EACE,oBAAA;EACA,mBAAA;AV8wGF;AU5wGE;EACE,YAAA;EACA,WAAA;AV8wGJ;;AUzwGI;EADF;IAEI,gBAAA;IACA,0BAAA;IACA,qBAAA;IACA,YAAA;EV6wGJ;AACF;;AU1wGA;EACE,4BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AV6wGF;AU3wGE;EAXF;IAYI,gBAAA;IACA,0BAAA;IACA,UAAA;IACA,YAAA;EV8wGF;AACF;AU5wGE;EACE,8BAAA;AV8wGJ;;AU1wGA;EACE,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AV6wGF;AU3wGE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EV8wGF;AACF;AU5wGE;EACE,8BAAA;AV8wGJ;;AU1wGA;EACE,8BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AV6wGF;AU3wGE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EV8wGF;AACF;;AU3wGA;;CAAA;AAGA;EACE,gBAAA;EACA,kBAAA;AV8wGF;;AU3wGA;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;AV8wGF;;AU5wGA;EACE,mDAAA;EACA,4CAAA;AV+wGF;;AU5wGA;EACE,sCAAA;EACA,kBAAA;EACA,yCAAA;AV+wGF;;AU7wGA;EACE,uBAAA;EACA,kBAAA;EACA,yCAAA;AVgxGF;;AU9wGA;EACE,kCAAA;EACA,kBAAA;EACA,kCAAA;AVixGF;;AU/wGA;EACE,2BAAA;AVkxGF;;AU/wGE;EACE,YAAA;AVkxGJ;AUhxGE;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,8BAAA;AVkxGJ;AU/wGI;EACE,yBAAA;EACA,oCAAA;AVixGN;AU7wGE;EACE,uBAAA;AV+wGJ;AU7wGE;EACE,uBAAA;AV+wGJ;AU7wGE;EACE,uBAAA;AV+wGJ;;AU3wGA;EACE;IACE,4BAAA;IACA,eAAA;EV8wGF;EU3wGA;IACE,2BAAA;IACA,4BAAA;IACA,eAAA;EV6wGF;EU1wGA;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;EV4wGF;EU1wGA;IACE,WAAA;IACA,gBAAA;IACA,4BAAA;IACA,2BAAA;EV4wGF;EU1wGA;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;EV4wGF;AACF;AUzwGA;EACE;IACE,kBAAA;EV2wGF;EUzwGA;IACE,iBAAA;IACA,2BAAA;IACA,eAAA;EV2wGF;EUxwGA;IACE,kBAAA;IACA,0BAAA;EV0wGF;EUxwGA;IACE,0BAAA;IACA,0BAAA;IACA,2BAAA;EV0wGF;EUxwGE;IACF,kBAAA;IACE,0BAAA;EV0wGF;AACF;AUvwGA;EACE;IACE,UAAA;EVywGF;AACF;AUtwGA;EACE,wCAAA;AVwwGF;;AUrwGA;EACE;IACE,iBAAA;IACA,8CAAA;EVwwGF;AACF;AUrwGA;EACE,kCAAA;EACA,oBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;AVuwGF;AUrwGE;EACE,sBAAA;AVuwGJ;;AUnwGA;EACE,wBAAA;AVswGF;;AUpwGA;EACE,qBAAA,EAAA,wCAAA;AVuwGF;;AUrwGA;EACE,iBAAA;EACA,iBAAA;EACA,yBAAA;AVwwGF;AUtwGE;EACE,UAAA;EACA,aAAA;EACA,YAAA;EAEA,8BAAA;EACA,aAAA;AVuwGJ;AUrwGI;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;AVuwGN;AUpwGI;;EAEE,eAAA;EACA,mBAAA;EACA,cAAA;AVswGN;AUpwGI;EApBF;IAqBI,WAAA;IACA,cAAA;EVuwGJ;AACF;AUpwGE;EACE,iBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AVswGJ;AUpwGI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AVswGN;AUlwGE;EACE,iBAAA;EACA,uBAAA;AVowGJ;AUjwGI;EADF;IAEI,eAAA;EVowGJ;AACF;AUjwGE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AVmwGJ;AUhwGE;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AVkwGJ;AUhwGI;EACE,iBAAA;AVkwGN;;AU7vGA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AVgwGF;;AU7vGA;EACE,kCAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AVgwGF;;AU7vGA;EACE,qBAAA;AVgwGF;;AU7vGA;EACE,kCAAA;EACA,YAAA;AVgwGF;;AU7vGA;EACE,kCAAA;EACA,YAAA;AVgwGF;;AU9vGA;EAEE,cAAA;EACA,yBAAA;EACA,mBAAA;AVgwGF;;AU5vGA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AV+vGF;;AU7vGA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AVgwGF;AU9vGE;EACE,WAAA;AVgwGJ;AU7vGE;EACE;IACE,aAAA;EV+vGJ;AACF;;AU3vGA;EACE,aAAA;EACA,mBAAA;AV8vGF;AU5vGE;EACE,WAAA;AV8vGJ;AU3vGE;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;AV6vGJ;AU1vGE;EACE,uBAAA;AV4vGJ;AUzvGE;EACE,uBAAA;AV2vGJ;;AUvvGA;;EAEE,mCAAA;EACA,6BAAA;EACA,yCAAA;EACA,4DAAA;EACA,0DAAA;EACA,0DAAA;AV0vGF;;AUvvGA;EACE,uBAAA;AV0vGF;;AUvvGA;EACE,aAAA;EACA,eAAA;AV0vGF;AUxvGE;EACE,kBAAA;EACA,iBAAA;EACA,2CAAA;EACA,WAAA;AV0vGJ;;AUtvGA;EACE,gBAAA;EACA,kBAAA;AVyvGF;;AUrvGA;EACE,iDAAA;EACA,oBAAA;EACA,wBAAA;EACA,uBAAA;AVwvGF;;AUpvGE;EACE,gBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,sBAAA;AVuvGJ;;AUlvGE;EACE,mCAAA;AVqvGJ;AUlvGE;EACE,wBAAA;EACA,kBAAA;AVovGJ;;AU/uGE;EACE,kCAAA;AVkvGJ;AU/uGE;EACE,uBAAA;EACA,kBAAA;AVivGJ;;AU7uGA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AVgvGF;AU9uGE;EACE,sCAAA;EACA,+CAAA;AVgvGJ;;AU5uGA;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AV+uGF;;AU5uGA,oCAAA;AACA;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AV+uGF;;AU5uGA;EAEE,qBAAA;AV8uGF;;AUvuGA;EAEE,cAAA;AVyuGF;;AUtuGA;EACM,2BAAA;AVyuGN;;AUvuGA;EACE,2BAAA;AV0uGF;;AUxuGA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AV2uGF;;AUxuGA;EACE,aAAA;EACA,iBAAA;AV2uGF;;AUxuGA;EACE,mCAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AV2uGF;AUzuGE;EACE,kBAAA;AV2uGJ;;AUvuGA;EACE,kBAAA;EACA,kBAAA;AV0uGF;;AUxuGA;EACE,YAAA;EAEA,wCAAA;EACA,yBAAA;EACA,kBAAA;AV0uGF;AUxuGE;EACE,gBAAA;AV0uGJ;AUxuGE;EACE,WAAA;AV0uGJ;;AUtuGA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;AVyuGF;;AUtuGA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AVyuGF;;AUtuGA;EACE,sBAAA;EACA,YAAA;AVyuGF;;AUtuGA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AVyuGF;;AUvuGA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;AV0uGF;;AUxuGA;EACE,iCAAA;AV2uGF;;AUzuGA;EACE,sBAAA;AV4uGF;;AU1uGA;EACE,iDAAA;EACA,mDAAA;AV6uGF;;AU1uGE;EACE,8BAAA;AV6uGJ;;AUzuGE;EACE,8BAAA;AV4uGJ;;AUzuGA;EACE,uBAAA;AV4uGF;;AU1uGA;EAEE,kCAAA;EACA,YAAA;EACA,kCAAA;EACA,6BAAA;AV4uGF;;AU1uGA;EACE,6BAAA;EACA,kBAAA;AV6uGF;;AU3uGA;EACE,oCAAA;AV8uGF;;AU5uGA;EACE,kCAAA;AV+uGF;;AU5uGE;EADF;IAEI,WAAA;EVgvGF;AACF;;AU7uGA;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AVgvGF;;AU5uGE;EACE,qBAAA;AV+uGJ;AUpuGA;EACI,eAAA;EACI,oBAAA;EACJ,aAAA;AVsuGJ;;AUpuGA;EACI,eAAA;EACE,oBAAA;EACF,aAAA;AVuuGJ;;AUpuGA;EACE,2BAAA;AVuuGF;;AUnuGE;EADF;IAEI,wBAAA;EVuuGF;AACF;;AUruGA;EACE,4CAAA;EACA,gDAAA,EAAA,iBAAA;EACA,sDAAA,EAAA,mBAAA;EACA,8CAAA;AVwuGF;;AUruGA;EAAO,iBAAA;AVyuGP;;AUxuGA;EAAO,uBAAA;AV4uGP;;AU3uGA;EAAO,sBAAA;AV+uGP;;AU9uGA;EAAO,oBAAA;AVkvGP;;AUjvGA;EAAO,sBAAA;AVqvGP;;AUpvGA;EAAO,oBAAA;AVwvGP;;AUrvGA;EAAQ,wBAAA;AVyvGR;;AUxvGA;EAAQ,8BAAA;AV4vGR;;AU3vGA;EAAQ,6BAAA;AV+vGR;;AU9vGA;EAAQ,2BAAA;AVkwGR;;AUjwGA;EAAQ,6BAAA;AVqwGR;;AUpwGA;EAAQ,2BAAA;AVwwGR;;AUrwGA;EAAQ,qBAAA;AVywGR;;AUxwGA;EAAQ,2BAAA;AV4wGR;;AU3wGA;EAAQ,0BAAA;AV+wGR;;AU9wGA;EAAQ,wBAAA;AVkxGR;;AUjxGA;EAAQ,0BAAA;AVqxGR;;AUpxGA;EAAQ,wBAAA;AVwxGR;;AUvxGA;EACE,YAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;AV0xGF;;AUvxGA;EAAS,mBAAA;EAAqB,oBAAA;AV4xG9B;;AU3xGA;EAAS,oBAAA;EAAsB,qBAAA;AVgyG/B;;AU/xGA;EAAS,aAAA;EAAe,cAAA;AVoyGxB;;AUnyGA;EAAS,oBAAA;EAAsB,qBAAA;AVwyG/B;;AUvyGA;EAAS,oBAAA;EAAsB,qBAAA;AV4yG/B;;AU3yGA;EAAS,aAAA;EAAe,cAAA;AVgzGxB;;AU/yGA;EAAS,oBAAA;EAAsB,qBAAA;AVozG/B;;AUnzGA;EAAS,oBAAA;EAAsB,qBAAA;AVwzG/B;;AUvzGA;EAAS,aAAA;EAAe,cAAA;AV4zGxB;;AU3zGA;EAAU,oBAAA;EAAsB,qBAAA;AVg0GhC;;AU/zGA;EAAU,oBAAA;EAAsB,qBAAA;AVo0GhC;;AUn0GA;EAAU,aAAA;EAAe,cAAA;AVw0GzB;;AUt0GA,wBAAA;AACA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EV20GjC;EU10GA;IAAY,oBAAA;IAAsB,qBAAA;EV80GlC;EU70GA;IAAY,aAAA;IAAe,cAAA;EVi1G3B;EUh1GA;IAAY,oBAAA;IAAsB,qBAAA;EVo1GlC;EUn1GA;IAAY,oBAAA;IAAsB,qBAAA;EVu1GlC;EUt1GA;IAAY,aAAA;IAAe,cAAA;EV01G3B;EUz1GA;IAAY,oBAAA;IAAsB,qBAAA;EV61GlC;EU51GA;IAAY,oBAAA;IAAsB,qBAAA;EVg2GlC;EU/1GA;IAAY,aAAA;IAAe,cAAA;EVm2G3B;EUl2GA;IAAa,oBAAA;IAAsB,qBAAA;EVs2GnC;EUr2GA;IAAa,oBAAA;IAAsB,qBAAA;EVy2GnC;EUx2GA;IAAa,aAAA;IAAe,cAAA;EV42G5B;AACF;AU12GA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EV82GjC;EU72GA;IAAY,oBAAA;IAAsB,qBAAA;EVi3GlC;EUh3GA;IAAY,aAAA;IAAe,cAAA;EVo3G3B;EUn3GA;IAAY,oBAAA;IAAsB,qBAAA;EVu3GlC;EUt3GA;IAAY,oBAAA;IAAsB,qBAAA;EV03GlC;EUz3GA;IAAY,aAAA;IAAe,cAAA;EV63G3B;EU53GA;IAAY,oBAAA;IAAsB,qBAAA;EVg4GlC;EU/3GA;IAAY,oBAAA;IAAsB,qBAAA;EVm4GlC;EUl4GA;IAAY,aAAA;IAAe,cAAA;EVs4G3B;EUr4GA;IAAa,oBAAA;IAAsB,qBAAA;EVy4GnC;EUx4GA;IAAa,oBAAA;IAAsB,qBAAA;EV44GnC;EU34GA;IAAa,cAAA;IAAgB,eAAA;EV+4G7B;AACF;AU74GA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVi5GjC;EUh5GA;IAAY,oBAAA;IAAsB,qBAAA;EVo5GlC;EUn5GA;IAAY,aAAA;IAAe,cAAA;EVu5G3B;EUt5GA;IAAY,oBAAA;IAAsB,qBAAA;EV05GlC;EUz5GA;IAAY,oBAAA;IAAsB,qBAAA;EV65GlC;EU55GA;IAAY,aAAA;IAAe,cAAA;EVg6G3B;EU/5GA;IAAY,oBAAA;IAAsB,qBAAA;EVm6GlC;EUl6GA;IAAY,oBAAA;IAAsB,qBAAA;EVs6GlC;EUr6GA;IAAY,aAAA;IAAe,cAAA;EVy6G3B;EUx6GA;IAAa,oBAAA;IAAsB,qBAAA;EV46GnC;EU36GA;IAAa,oBAAA;IAAsB,qBAAA;EV+6GnC;EU96GA;IAAa,aAAA;IAAe,cAAA;EVk7G5B;AACF;AUh7GA,6BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVo7GjC;EUn7GA;IAAY,oBAAA;IAAsB,qBAAA;EVu7GlC;EUt7GA;IAAY,aAAA;IAAe,cAAA;EV07G3B;EUz7GA;IAAY,oBAAA;IAAsB,qBAAA;EV67GlC;EU57GA;IAAY,oBAAA;IAAsB,qBAAA;EVg8GlC;EU/7GA;IAAY,aAAA;IAAe,cAAA;EVm8G3B;EUl8GA;IAAY,oBAAA;IAAsB,qBAAA;EVs8GlC;EUr8GA;IAAY,oBAAA;IAAsB,qBAAA;EVy8GlC;EUx8GA;IAAY,aAAA;IAAe,cAAA;EV48G3B;EU38GA;IAAa,oBAAA;IAAsB,qBAAA;EV+8GnC;EU98GA;IAAa,oBAAA;IAAsB,qBAAA;EVk9GnC;EUj9GA;IAAa,aAAA;IAAe,cAAA;EVq9G5B;AACF;AUn9GA,6BAAA,QAAA;EACE;IAAa,mBAAA;IAAqB,oBAAA;EVu9GlC;EUt9GA;IAAa,oBAAA;IAAsB,qBAAA;EV09GnC;EUz9GA;IAAa,aAAA;IAAe,cAAA;EV69G5B;EU59GA;IAAa,oBAAA;IAAsB,qBAAA;EVg+GnC;EU/9GA;IAAa,oBAAA;IAAsB,qBAAA;EVm+GnC;EUl+GA;IAAa,aAAA;IAAe,cAAA;EVs+G5B;EUr+GA;IAAa,oBAAA;IAAsB,qBAAA;EVy+GnC;EUx+GA;IAAa,oBAAA;IAAsB,qBAAA;EV4+GnC;EU3+GA;IAAa,aAAA;IAAe,cAAA;EV++G5B;EU9+GA;IAAc,oBAAA;IAAsB,qBAAA;EVk/GpC;EUj/GA;IAAc,oBAAA;IAAsB,qBAAA;EVq/GpC;EUp/GA;IAAc,aAAA;IAAe,cAAA;EVw/G7B;AACF;AUv/GA;EACE,0BAAA;AVy/GF;;AUv/GA;EACE,iBAAA;AV0/GF;;AUx/GA;EACI,4CAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;AV2/GJ;;AUx/GA;EACI,uBAAA;AV2/GJ;;AUx/GA;EACI,aAAA;AV2/GJ;;AUx/GA;EAEI,gCAAA;EACA,oCAAA;AV0/GJ;;AA/2IA;EACE,aAAA;EACA,uBAAA;AAk3IF;AAh3IE;EAEE,aAAA;EACA,eAAA;EAMA,gJAAA;AA42IJ;AAh3II;EALF;IAMI,sBAAA;EAm3IJ;AACF;AA/2II;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mCAAA;EACA,YAAA;AAi3IN;AA72IE;EACE,mBAAA;EACA,gBAAA;AA+2IJ;AA12IE;EAEE,aAAA;EACA,mBAAA;EACA,8BAAA;AA22IJ;AAx2II;EAEE,UAAA;EACA,mBAAA;EAEA,uBAAA;AAw2IN;AAt2IM;EACE,uBAAA;EACA,oCAAA;AAw2IR;AAr2IM;EACE,kCAAA;AAu2IR;AAp2IM;EACE,kCAAA;AAs2IR;AAn2IM;EACE,aAAA;AAq2IR;AAl2IM;EACE,yBAAA;EACA,gBAAA;EACA,qBAAA;AAo2IR;AA51II;EACE,mCAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AA81IN;AA51IM;EACE,OAAA;AA81IR;AA31IM;EACE,mBAAA;AA61IR;AAx1IE;EACE,aAAA;EACA,qBAAA;EACA,yBAAA;AA01IJ;AAx1II;EACE,iBAAA;EACA,oBAAA;AA01IN;AAv1II;EACE,6BAAA;AAy1IN;AAr1IE;EACE,mBAAA;AAu1IJ;AAp1IE;EACE,WAAA;AAs1IJ;AAn1IE;EACE,gBAAA;AAq1IJ;AAh1IE;EACE,cAAA;AAk1IJ;AAh1II;EACE,eAAA;AAk1IN;AA90IE;EACE,aAAA;EACA,mBAAA;AAg1IJ;AA90II;EACE,WAAA;AAg1IN;AA70II;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;AA+0IN;AA50II;EACE,uBAAA;AA80IN;AA30II;EACE,uBAAA;AA60IN;AAz0IE;EACE,aAAA;EACA,qBAAA;AA20IJ;AAz0II;EACE,YAAA;AA20IN;AAv0IE;EACE,uBAAA;AAy0IJ;;AAr0IA;EACE,gCAAA;AAw0IF;;AAr0IA;EACE,8BAAA;AAw0IF;;AAr0IA;EACE,gBAAA;AAw0IF;;AAr0IA;EAEE;IACE,sBAAA;IACA,mBAAA;EAu0IF;EAp0IA;IACE,sBAAA;IACA,iBAAA;EAs0IF;EAn0IA;IACE,WAAA;IACA,iBAAA;IACA,sBAAA;IACA,mBAAA;EAq0IF;EAn0IE;IACE,WAAA;IACA,uBAAA;IACA,mBAAA;EAq0IJ;EAj0IA;IACE,iBAAA;EAm0IF;AACF;AAh0IA;EACE,0BAAA;AAk0IF;;AA/zIA;EACE,0BAAA;AAk0IF;;AA9zIA;EACE;IACE,qBAAA;IACA,iBAAA;EAi0IF;EA9zIA;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,8BAAA;EAg0IF;EA9zIE;IACE,UAAA;EAg0IJ;EA7zIE;IACE,qBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EA+zIJ;AACF;AA3zIA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AA6zIF;AA3zIE;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;AA6zIJ;;AAzzIA;EAEE;IACE,aAAA;IACA,mBAAA;IACA,8BAAA;EA2zIF;EAzzIE;IACE,UAAA;IACA,iBAAA;IACA,iBAAA;EA2zIJ;AACF;AAtzIA;EACE;IACE,UAAA;EAwzIF;EArzIA;IAEE,aAAA;IACA,mBAAA;IACA,8BAAA;EAszIF;EApzIE;IACE,UAAA;IACA,iBAAA;IACA,iBAAA;EAszIJ;AACF;AAlzIA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;AAozIF","sourcesContent":["@import \"src/styles\";\n\n.content{\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n\n}\n.disabled-button {\n  background-color: rgba(112, 111, 111, 1) !important;\n  color: white;\n  border: 2px solid rgba(112, 111, 111, 1) !important;\n  cursor: not-allowed;\n\n}\n.header {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n\n  .mat-mdc-form-field {\n    width: 100% !important;\n  }\n\n  .filtered-more-options {\n\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n\n    @media (max-width: 1024px) {\n      width: 98%;\n    }\n\n    .mat-mdc-form-field {\n      width: 100% !important;\n\n\n    }\n\n    .row-filter {\n      button {\n        cursor: pointer;\n        // margin: 1rem;\n        padding: 1rem 2rem;\n        background-color: rgba(174, 15, 10, 1);\n        color: #fff;\n        border: none;\n        border-radius: .6rem;\n        width: 100%;\n\n        @media (max-width: 1024px) {\n          margin-top: 15px;\n        }\n      }\n\n    }\n  }\n  @media (max-width: 1024px) {\n    width: 98%;\n  }\n}\n.legend {\n  border-bottom: 1px solid black;\n  padding: 1rem;\n  font-weight: bold;\n  margin: 1rem auto;\n  display: flex;\n  width: 100%;\n  .btn-adc {\n    display: flex;\n    margin-left: 16px;\n    font-family: \"Barlow\", sans-serif !important;\n    min-width: 150px;\n    align-items: flex-start;\n    img{\n      width: 24px;\n    }\n  }\n}\n.actions-cell button {\n  float: right;\n}\n\n.mat-expansion-panel-body {\n  padding: 0rem !important;\n}\n\n.button-list {\n  box-shadow: 1px 1px 1px 1px #cdcdcd;\n  padding: .5rem 5rem;\n  display: flex;\n  align-items: center;\n  flex-direction: row-reverse;\n  margin-bottom: 6px;\n\n  .spacer {\n    flex: 1;\n  }\n\n  .mat-icon {\n    margin-left: 0.5rem;\n  }\n}\n\n.header-more-filter-btn-component {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.table-component {\n  table {\n    table-layout: fixed;\n  }\n  @media (max-width: 1024px) {\n    width: 98%;\n  }\n}\n\n@media(min-width: 1025px) {\n  .header {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    justify-content: space-between;\n\n    .mat-mdc-form-field {\n      width: 20% !important;\n    }\n\n    .filtered-more-options {\n      width: 75%;\n\n      .mat-mdc-form-field {\n        width: 70% !important;\n\n\n      }\n\n      .row-filter {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n\n        button {\n          margin: 1rem;\n          width: 40%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        }\n      }\n    }\n  }\n}\n\ntable {\n  width: 100%;\n  box-shadow: none;\n  background-color: transparent;\n  overflow: auto;\n}\n\ntr.example-detail-row {\n  height: 0;\n}\n\ntr.example-element-row:not(.example-expanded-row):hover {\n  background: whitesmoke;\n}\n\ntr.example-element-row:not(.example-expanded-row):active {\n  background: #efefef;\n}\n\n\n.header-expanded-table {\n\n  .mat-mdc-form-field {\n    width: 100%;\n  }\n\n  button {\n    cursor: pointer;\n    padding: 1rem 2rem;\n    background-color: rgba(174, 15, 10, 1);\n    color: #fff;\n    border: none;\n    border-radius: .6rem;\n    width: 100%;\n    // margin-top: -0.7rem !important;\n  }\n}\n\n.title {\n  font-size: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  font-weight: bold;\n\n  .description {\n    font-size: 1rem;\n    font-weight: normal;\n  }\n}\n\n@import \"src/styles\";\n\n\n\n.entities-list-container {\n  padding: 1rem;\n  background-color: white;\n\n  .entitie-filters {\n    // width: 90%;\n    display: flex;\n    flex-wrap: wrap;\n\n    @media (max-width: 1024px) {\n      flex-direction: column;\n    }\n\n    transform: var(--mat-mdc-form-field-label-transform, translateY(0%) translateX(calc(1*(0px + var(--mat-mdc-form-field-label-offset-x, 0px)))));\n\n    .search-input {\n      border: 1px solid;\n      border-radius: 7px;\n      display: flex;\n      align-items: center;\n      box-shadow: 1px 1px 1px 1px #cdcdcd;\n      flex-grow: 3;\n    }\n  }\n\n  h6 {\n    margin-bottom: 1rem;\n    margin-top: 1rem;\n  }\n\n\n\n  .filtros {\n    // width: 90%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n\n    .fast-filter {\n      // flex-grow: 1;\n      width: 30%;\n      align-items: center;\n      // margin-left: 1rem;\n      background: transparent;\n\n      .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {\n        background-color: white;\n        border: 1px solid map-get($medium-color, 500);\n      }\n\n      .filter-by-active-entitie.mat-mdc-chip-selected.mdc-evolution-chip--selected {\n        background-color: map-get($success-color, 700);\n      }\n\n      .filter-by-inactive-entitie.mat-mdc-chip-selected.mdc-evolution-chip--selected {\n        background-color: map-get($danger-color, 500);\n      }\n\n      .mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {\n        display: none;\n      }\n\n      span {\n        color: map-get($medium-color, 500);\n        font-weight: 400;\n        align-content: center;\n      }\n    }\n\n\n\n\n\n    .button-list {\n      box-shadow: 1px 1px 1px 1px #cdcdcd;\n      padding: .5rem 5rem;\n      display: flex;\n      align-items: center;\n      flex-direction: row-reverse;\n      margin-bottom: 6px;\n\n      .spacer {\n        flex: 1;\n      }\n\n      .mat-icon {\n        margin-left: 0.5rem;\n      }\n    }\n  }\n\n  .more-filters {\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-end;\n\n    .mat-mdc-form-field {\n      margin: 0rem 2rem;\n      margin-bottom: -1rem;\n    }\n\n    .mat-picker {\n      margin-right: 0rem !important;\n    }\n  }\n\n  mat-form-field {\n    margin-bottom: 16px;\n  }\n\n  table {\n    width: 100%;\n  }\n\n  th {\n    font-weight: 700;\n  }\n\n\n\n  .entitie-list-table-wrapper {\n    overflow: auto;\n\n    th {\n      cursor: pointer;\n    }\n  }\n\n  .status-container {\n    display: flex;\n    align-items: center;\n\n    .mat-icon {\n      width: 1rem;\n    }\n\n    .status-icon {\n      font-size: 8px;\n      align-content: center;\n      text-align: center;\n    }\n\n    .active {\n      color: map-get($success-color, 700);\n    }\n\n    .inactive {\n      color: map-get($danger-color, 500);\n    }\n  }\n\n  .create-entitie-link {\n    display: flex;\n    margin-bottom: 1.5rem;\n\n    mat-icon {\n      height: 1rem;\n    }\n  }\n\n  .icon-entitie-actions-menu {\n    color: map-get($primary-color, 500);\n  }\n}\n\n::ng-deep .mat-calendar-body-selected {\n  background-color: red !important;\n}\n\n::ng-deep .mat-calendar-body-cell-content {\n  border-radius: 0rem !important;\n}\n\n::ng-deep .mat-calendar-body-selected.mat-calendar-body-today {\n  box-shadow: none;\n}\n\n@media(max-width:1025px) {\n\n  .filtros {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .fast-filter {\n    width: 100% !important;\n    margin: 1rem 0rem;\n  }\n\n  .more-filters {\n    width: 100%;\n    margin: 1rem auto;\n    flex-direction: column;\n    align-items: center;\n\n    .mat-mdc-form-field {\n      width: 100%;\n      margin: 0rem !important;\n      margin-bottom: 1rem;\n    }\n  }\n\n  .label {\n    font-size: 0.7rem;\n  }\n}\n\n::ng-deep .mat-mdc-form-field-label {\n  transform: none !important;\n}\n\n.mat-mdc-form-field-label {\n  transform: none !important;\n}\n\n\n@media(min-width:1025px) {\n  .fast-filter {\n    width: 50% !important;\n    margin: 1rem 0rem;\n  }\n\n  .header-expanded-table {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n\n    .mat-mdc-form-field {\n      width: 70%;\n    }\n\n    button {\n      width: 40% !important;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n}\n\n.paginator-segment {\n  flex-direction: column;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  p {\n    width: 100%;\n    font-size: 1.5rem;\n    font-weight: bold;\n  }\n}\n\n@media(min-width: 1025px) {\n\n  .paginator-segment {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    p {\n      width: 50%;\n      font-size: 1.5rem;\n      font-weight: bold;\n    }\n  }\n}\n\n\n@media(min-width: 1025px) {\n  #paginator {\n    width: 80%;\n  }\n  \n  .paginator-segment {\n\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  \n    p {\n      width: 20%;\n      font-size: 1.5rem;\n      font-weight: bold;\n    }\n  }\n}\n\n.importar{\n  width: 25px;\n  height: 25px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 2px solid rgb(174, 15, 10);\n  border-radius: 8px;\n  cursor: pointer;\n}","@use '@angular/cdk';\n\n@mixin ripple() {\n  // The host element of an mat-ripple directive should always have a position of \"absolute\" or\n  // \"relative\" so that the ripples inside are correctly positioned relatively to the container.\n  .mat-ripple {\n    overflow: hidden;\n\n    // By default, every ripple container should have position: relative in favor of creating an\n    // easy API for developers using the MatRipple directive.\n    position: relative;\n\n    // Promote containers that have ripples to a new layer. We want to target `:not(:empty)`,\n    // because we don't want all ripple containers to have their own layer since they're used in a\n    // lot of places and the layer is only relevant while animating. Note that ideally we'd use\n    // the `contain` property here (see #13175), because `:empty` can be broken by having extra\n    // text inside the element, but it isn't very well supported yet.\n    &:not(:empty) {\n      transform: translateZ(0);\n    }\n  }\n\n  .mat-ripple.mat-ripple-unbounded {\n    overflow: visible;\n  }\n\n  .mat-ripple-element {\n    position: absolute;\n    border-radius: 50%;\n    pointer-events: none;\n\n    transition: opacity, transform 0ms cubic-bezier(0, 0, 0.2, 1);\n\n    // We use a 3d transform here in order to avoid an issue in Safari where\n    // the ripples aren't clipped when inside the shadow DOM (see #24028).\n    transform: scale3d(0, 0, 0);\n\n    // In high contrast mode the ripple is opaque, causing it to obstruct the content.\n    @include cdk.high-contrast(active, off) {\n      display: none;\n    }\n  }\n}\n","/// Emits a CSS class, `.cdk-visually-hidden`. This class can be applied to an element\n/// to make that element visually hidden while remaining available to assistive technology.\n@mixin a11y-visually-hidden() {\n  .cdk-visually-hidden {\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n\n    // This works around a Chrome bug that can cause the tab to crash when large amounts of\n    // non-English text get wrapped: https://bugs.chromium.org/p/chromium/issues/detail?id=1201444\n    white-space: nowrap;\n\n    // Avoid browsers rendering the focus ring in some cases.\n    outline: 0;\n\n    // Avoid some cases where the browser will still render the native controls (see #9049).\n    -webkit-appearance: none;\n    -moz-appearance: none;\n\n    // We need at least one of top/bottom/left/right in order to prevent cases where the\n    // absolute-positioned element is pushed down and can affect scrolling (see #24597).\n    // `left` was chosen here, because it's the least likely to break overrides where the\n    // element might have been positioned (e.g. `mat-checkbox`).\n    left: 0;\n\n    [dir='rtl'] & {\n      left: auto;\n      right: 0;\n    }\n  }\n}\n\n/// @deprecated Use `a11y-visually-hidden`.\n@mixin a11y() {\n  @include a11y-visually-hidden;\n}\n\n/// Emits the mixin's content nested under `$selector-context` if `$selector-context`\n/// is non-empty.\n/// @param {String} selector-context The selector under which to nest the mixin's content.\n@mixin _optionally-nest-content($selector-context) {\n  @if ($selector-context == '') {\n    @content;\n  }\n  @else {\n    #{$selector-context} {\n      @content;\n    }\n  }\n}\n\n/// Applies styles for users in high contrast mode. Note that this only applies\n/// to Microsoft browsers. Chrome can be included by checking for the `html[hc]`\n/// attribute, however Chrome handles high contrast differently.\n///\n/// @param {String} target Type of high contrast setting to target. Defaults to `active`, can be\n///     `white-on-black` or `black-on-white`.\n/// @param {String} encapsulation Whether to emit styles for view encapsulation. Values are:\n///     * `on` - works for `Emulated`, `Native`, and `ShadowDom`\n///     * `off` - works for `None`\n///     * `any` - works for all encapsulation modes by emitting the CSS twice (default).\n@mixin high-contrast($target: active, $encapsulation: 'any') {\n  @if ($target != 'active' and $target != 'black-on-white' and $target != 'white-on-black') {\n    @error 'Unknown cdk-high-contrast value \"#{$target}\" provided. ' +\n           'Allowed values are \"active\", \"black-on-white\", and \"white-on-black\"';\n  }\n\n  @if ($encapsulation != 'on' and $encapsulation != 'off' and $encapsulation != 'any') {\n    @error 'Unknown cdk-high-contrast encapsulation \"#{$encapsulation}\" provided. ' +\n           'Allowed values are \"on\", \"off\", and \"any\"';\n  }\n\n  // If the selector context has multiple parts, such as `.section, .region`, just doing\n  // `.cdk-high-contrast-xxx #{&}` will only apply the parent selector to the first part of the\n  // context. We address this by nesting the selector context under .cdk-high-contrast.\n  @at-root {\n    $selector-context: #{&};\n\n    @if ($encapsulation != 'on') {\n      // Note that if this selector is updated, the same change has to be made inside\n      // `_overlay.scss` which can't depend on this mixin due to some infrastructure limitations.\n      .cdk-high-contrast-#{$target} {\n        @include _optionally-nest-content($selector-context) {\n          @content;\n        }\n      }\n    }\n\n    @if ($encapsulation != 'off') {\n      .cdk-high-contrast-#{$target} :host {\n        @include _optionally-nest-content($selector-context) {\n          @content;\n        }\n      }\n    }\n  }\n}\n","// We want overlays to always appear over user content, so set a baseline\n// very high z-index for the overlay container, which is where we create the new\n// stacking context for all overlays.\n$overlay-container-z-index: 1000 !default;\n$overlay-z-index: 1000 !default;\n$overlay-backdrop-z-index: 1000 !default;\n\n// Background color for all of the backdrops\n$overlay-backdrop-color: rgba(0, 0, 0, 0.32) !default;\n\n// Default backdrop animation is based on the Material Design swift-ease-out.\n$backdrop-animation-duration: 400ms !default;\n$backdrop-animation-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1) !default;\n\n/// Emits structural styles required for cdk/overlay to function.\n@mixin overlay() {\n  .cdk-overlay-container, .cdk-global-overlay-wrapper {\n    // Disable events from being captured on the overlay container.\n    pointer-events: none;\n\n    // The container should be the size of the viewport.\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n  }\n\n  // The overlay-container is an invisible element which contains all individual overlays.\n  .cdk-overlay-container {\n    position: fixed;\n    z-index: $overlay-container-z-index;\n\n    &:empty {\n      // Hide the element when it doesn't have any child nodes. This doesn't\n      // include overlays that have been detached, rather than disposed.\n      display: none;\n    }\n  }\n\n  // We use an extra wrapper element in order to use make the overlay itself a flex item.\n  // This makes centering the overlay easy without running into the subpixel rendering\n  // problems tied to using `transform` and without interfering with the other position\n  // strategies.\n  .cdk-global-overlay-wrapper {\n    display: flex;\n    position: absolute;\n    z-index: $overlay-z-index;\n  }\n\n  // A single overlay pane.\n  .cdk-overlay-pane {\n    // Note: it's important for this one to start off `absolute`,\n    // in order for us to be able to measure it correctly.\n    position: absolute;\n    pointer-events: auto;\n    box-sizing: border-box;\n    z-index: $overlay-z-index;\n\n    // For connected-position overlays, we set `display: flex` in\n    // order to force `max-width` and `max-height` to take effect.\n    display: flex;\n    max-width: 100%;\n    max-height: 100%;\n  }\n\n  .cdk-overlay-backdrop {\n    // TODO(jelbourn): reuse sidenav fullscreen mixin.\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n\n    z-index: $overlay-backdrop-z-index;\n    pointer-events: auto;\n    -webkit-tap-highlight-color: transparent;\n    transition: opacity $backdrop-animation-duration $backdrop-animation-timing-function;\n    opacity: 0;\n\n    &.cdk-overlay-backdrop-showing {\n      opacity: 1;\n\n      // Note that we can't import and use the `high-contrast` mixin from `_a11y.scss`, because\n      // this file will be copied to the top-level `cdk` package when putting together the files\n      // for npm. Any relative import paths we use here will become invalid once the file is copied.\n      .cdk-high-contrast-active & {\n        // In high contrast mode the rgba background will become solid\n        // so we need to fall back to making it opaque using `opacity`.\n        opacity: 0.6;\n      }\n    }\n  }\n\n  .cdk-overlay-dark-backdrop {\n    background: $overlay-backdrop-color;\n  }\n\n  .cdk-overlay-transparent-backdrop {\n    // Define a transition on the visibility so that the `transitionend` event can fire immediately.\n    transition: visibility 1ms linear, opacity 1ms linear;\n    visibility: hidden;\n    opacity: 1;\n\n    // Note: as of Firefox 57, having the backdrop be `background: none` will prevent it from\n    // capturing the user's mouse scroll events. Since we also can't use something like\n    // `rgba(0, 0, 0, 0)`, we work around the inconsistency by not setting the background at\n    // all and using `opacity` to make the element transparent.\n    &.cdk-overlay-backdrop-showing {\n      opacity: 0;\n      visibility: visible;\n    }\n  }\n\n  .cdk-overlay-backdrop-noop-animation {\n    transition: none;\n  }\n\n  // Overlay parent element used with the connected position strategy. Used to constrain the\n  // overlay element's size to fit within the viewport.\n  .cdk-overlay-connected-position-bounding-box {\n    position: absolute;\n    z-index: $overlay-z-index;\n\n    // We use `display: flex` on this element exclusively for centering connected overlays.\n    // When *not* centering, a top/left/bottom/right will be set which overrides the normal\n    // flex layout.\n    display: flex;\n\n    // We use the `column` direction here to avoid some flexbox issues in Edge\n    // when using the \"grow after open\" options.\n    flex-direction: column;\n\n    // Add some dimensions so the element has an `innerText` which some people depend on in tests.\n    min-width: 1px;\n    min-height: 1px;\n  }\n\n  // Used when disabling global scrolling.\n  .cdk-global-scrollblock {\n    position: fixed;\n\n    // Necessary for the content not to lose its width. Note that we're using 100%, instead of\n    // 100vw, because 100vw includes the width plus the scrollbar, whereas 100% is the width\n    // that the element had before we made it `fixed`.\n    width: 100%;\n\n    // Note: this will always add a scrollbar to whatever element it is on, which can\n    // potentially result in double scrollbars. It shouldn't be an issue, because we won't\n    // block scrolling on a page that doesn't have a scrollbar in the first place.\n    overflow-y: scroll;\n  }\n}\n","// Structural styles for the autosize text fields.\n@mixin text-field-autosize() {\n  // Remove the resize handle on autosizing textareas, because whatever height\n  // the user resized to will be overwritten once they start typing again.\n  textarea.cdk-textarea-autosize {\n    resize: none;\n  }\n\n  // This class is temporarily applied to the textarea when it is being measured. It is immediately\n  // removed when measuring is complete. We use `!important` rules here to make sure user-specified\n  // rules do not interfere with the measurement.\n  textarea.cdk-textarea-autosize-measuring {\n    @include _autosize-measuring-base;\n    height: auto !important;\n    overflow: hidden !important;\n  }\n\n  // Similar to the `cdk-textarea-autosize-measuring` class, but only applied on Firefox. We need\n  // to use this class, because Firefox has a bug where changing the `overflow` breaks the user's\n  // ability to undo/redo what they were typing (see #16629). This class is only scoped to Firefox,\n  // because the measurements there don't seem to be affected by the `height: 0`, whereas on other\n  // browsers they are, e.g. Chrome detects longer text and IE does't resize back to normal.\n  // Identical issue report: https://bugzilla.mozilla.org/show_bug.cgi?id=448784\n  textarea.cdk-textarea-autosize-measuring-firefox {\n    @include _autosize-measuring-base;\n    height: 0 !important;\n  }\n}\n\n// Core styles that enable monitoring autofill state of text fields.\n@mixin text-field-autofill() {\n  // Keyframes that apply no styles, but allow us to monitor when an text field becomes autofilled\n  // by watching for the animation events that are fired when they start. Note: the /*!*/ comment is\n  // needed to prevent LibSass from stripping the keyframes out.\n  // Based on: https://medium.com/@brunn/detecting-autofilled-fields-in-javascript-aed598d25da7\n  @keyframes cdk-text-field-autofill-start {/*!*/}\n  @keyframes cdk-text-field-autofill-end {/*!*/}\n\n  .cdk-text-field-autofill-monitored:-webkit-autofill {\n    // Since Chrome 80 we need a 1ms delay, or the animationstart event won't fire.\n    animation: cdk-text-field-autofill-start 0s 1ms;\n  }\n\n  .cdk-text-field-autofill-monitored:not(:-webkit-autofill) {\n    // Since Chrome 80 we need a 1ms delay, or the animationstart event won't fire.\n    animation: cdk-text-field-autofill-end 0s 1ms;\n  }\n}\n\n@mixin _autosize-measuring-base {\n  // Having 2px top and bottom padding seems to fix a bug where Chrome gets an incorrect\n  // measurement. We just have to account for it later and subtract it off the final result.\n  padding: 2px 0 !important;\n  box-sizing: content-box !important;\n}\n\n// Used to generate UIDs for keyframes used to change the text field autofill styles.\n$autofill-color-frame-count: 0;\n\n// Mixin used to apply custom background and foreground colors to an autofilled text field.\n// Based on: https://stackoverflow.com/questions/2781549/\n// removing-input-background-colour-for-chrome-autocomplete#answer-37432260\n@mixin text-field-autofill-color($background, $foreground:'') {\n  @keyframes cdk-text-field-autofill-color-#{$autofill-color-frame-count} {\n    to {\n      background: $background;\n      @if $foreground != '' { color: $foreground; }\n    }\n  }\n\n  &:-webkit-autofill {\n    animation: cdk-text-field-autofill-color-#{$autofill-color-frame-count} both;\n  }\n\n  &.cdk-text-field-autofill-monitored:-webkit-autofill {\n    // Since Chrome 80 we need a 1ms delay for cdk-text-field-autofill-start, or the animationstart\n    // event won't fire.\n    animation: cdk-text-field-autofill-start 0s 1ms,\n               cdk-text-field-autofill-color-#{$autofill-color-frame-count} both;\n  }\n\n  $autofill-color-frame-count: $autofill-color-frame-count + 1 !global;\n}\n\n// @deprecated Use `autosize` and `autofill` instead.\n@mixin text-field {\n  @include text-field-autosize();\n  @include text-field-autofill();\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use '@angular/cdk';\n@use '../style/layout-common';\n@use '../theming/theming';\n\n// Private sass variables that will be used as reference throughout component stylesheets.\n$default-border-width: 3px;\n$default-border-style: solid;\n$default-border-color: transparent;\n$default-border-radius: 4px;\n\n// Mixin that renders the focus indicator structural styles.\n@mixin structural-styling($prefix) {\n  .#{$prefix}-focus-indicator {\n    position: relative;\n\n    &::before {\n      @include layout-common.fill();\n      box-sizing: border-box;\n      pointer-events: none;\n      display: var(--#{$prefix}-focus-indicator-display, none); // Hide the indicator by default.\n      border: var(\n          --#{$prefix}-focus-indicator-border-width,\n          #{$default-border-width}\n        )\n        var(\n          --#{$prefix}-focus-indicator-border-style,\n          #{$default-border-style}\n        )\n        var(\n          --#{$prefix}-focus-indicator-border-color,\n          #{$default-border-color}\n        );\n      border-radius: var(\n        --#{$prefix}-focus-indicator-border-radius,\n        #{$default-border-radius}\n      );\n    }\n\n    // By default, render the focus indicator when the focus indicator host element takes focus.\n    // Defining a pseudo element's content will cause it to render.\n    &:focus::before {\n      content: '';\n    }\n  }\n\n  // Enable the indicator in high contrast mode.\n  @include cdk.high-contrast(active, off) {\n    @include customize-focus-indicators((display: block), $prefix);\n  }\n}\n\n// Generates CSS variable declarations from a map.\n@mixin _output-variables($map) {\n  @each $key, $value in $map {\n    @if ($value) {\n      --#{$key}: #{$value};\n    }\n  }\n}\n\n// Mixin that dedups CSS variables for the strong-focus-indicators mixin.\n@mixin customize-focus-indicators($config, $prefix) {\n  $border-style: map.get($config, border-style);\n  $border-width: map.get($config, border-width);\n  $border-radius: map.get($config, border-radius);\n  $border-color: map.get($config, border-color);\n  $display: map.get($config, display);\n  $map: (\n    '#{$prefix}-focus-indicator-border-style': $border-style,\n    '#{$prefix}-focus-indicator-border-width': $border-width,\n    '#{$prefix}-focus-indicator-border-radius': $border-radius,\n    '#{$prefix}-focus-indicator-border-color': $border-color,\n    '#{$prefix}-focus-indicator-display': $display,\n  );\n\n  @if (&) {\n    @include _output-variables($map);\n  }\n  @else {\n    // We use `html` here instead of `:root`, because the\n    // latter causes some issues with internal tooling.\n    html {\n      @include _output-variables($map);\n    }\n  }\n}\n\n@mixin strong-focus-indicators($config: ()) {\n  // Default focus indicator config.\n  $default-config: (\n      border-color: black,\n      display: block,\n  );\n\n  // Merge default config with user config.\n  $config: map.merge($default-config, $config);\n\n  @include customize-focus-indicators($config, 'mat');\n}\n\n@mixin mdc-strong-focus-indicators($config: ()) {\n  // Default focus indicator config.\n  $default-config: (\n      border-color: black,\n      display: block,\n  );\n\n  // Merge default config with user config.\n  $config: map.merge($default-config, $config);\n\n  @include customize-focus-indicators($config, 'mat-mdc');\n}\n\n@mixin strong-focus-indicators-color($config-or-theme-or-color) {\n  @if meta.type-of($config-or-theme-or-color) == 'color' {\n    @include customize-focus-indicators((\n        border-color: $config-or-theme-or-color\n    ), 'mat');\n  }\n  @else {\n    $config: theming.get-color-config($config-or-theme-or-color);\n    $border-color: theming.get-color-from-palette(map.get($config, primary));\n    @include customize-focus-indicators((\n        border-color: $border-color\n    ), 'mat');\n  }\n}\n\n@mixin strong-focus-indicators-theme($theme-or-color-config-or-color) {\n  @if meta.type-of($theme-or-color-config-or-color) == 'color' {\n    @include customize-focus-indicators((\n        border-color: $theme-or-color-config-or-color\n    ), 'mat');\n  }\n  @else {\n    $theme: theming.private-legacy-get-theme($theme-or-color-config-or-color);\n    @include theming.private-check-duplicate-theme-styles($theme, 'mat-focus-indicators') {\n      $color: theming.get-color-config($theme);\n      @if $color != null {\n        @include strong-focus-indicators-color($color);\n      }\n    }\n  }\n}\n\n@mixin mdc-strong-focus-indicators-color($config-or-theme-or-color) {\n  @if meta.type-of($config-or-theme-or-color) == 'color' {\n    @include customize-focus-indicators((\n        border-color: $config-or-theme-or-color\n    ), 'mat-mdc');\n  }\n  @else {\n    $config: theming.get-color-config($config-or-theme-or-color);\n    $border-color: theming.get-color-from-palette(map.get($config, primary));\n    @include customize-focus-indicators((\n        border-color: $border-color\n    ), 'mat-mdc');\n  }\n}\n\n@mixin mdc-strong-focus-indicators-theme($theme-or-color-config-or-color) {\n  @if meta.type-of($theme-or-color-config-or-color) == 'color' {\n    @include customize-focus-indicators((\n        border-color: $theme-or-color-config-or-color\n    ), 'mat-mdc');\n  }\n  @else {\n    $theme: theming.private-legacy-get-theme($theme-or-color-config-or-color);\n    @include theming.private-check-duplicate-theme-styles($theme, 'mat-mdc-focus-indicators') {\n      $color: theming.get-color-config($theme);\n      @if $color != null {\n        @include mdc-strong-focus-indicators-color($color);\n      }\n    }\n  }\n}\n","// This mixin ensures an element spans to fill the nearest ancestor with defined positioning.\n@mixin fill {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: absolute;\n}\n","/* \n\tColors values \n\t300 = tint\n\t500 = default\n\t700 = shade\n*/\n$primary-color: (\n  500: rgba(174, 15, 10, 1),\n  300: rgba(227, 6, 19, 1),\n  700: rgba(228, 173, 181, 1),\n  contrast: (500: white,\n    300: white,\n    700: black,\n  ),\n);\n$secondary-color: (\n  500: rgba(0, 87, 158, 1),\n  300: rgba(51, 125, 192, 1),\n  700: rgba(0, 59, 109, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$warning-color: (\n  500: rgba(255, 196, 9, 1),\n  300: rgba(255, 202, 34, 1),\n  700: rgba(224, 172, 8, 1),\n  contrast: (500: black,\n    300: black,\n    700: black,\n  ),\n);\n\n$danger-color: (\n  500: rgba(235, 68, 90, 1),\n  300: rgba(237, 87, 107, 1),\n  700: rgba(207, 60, 79, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$success-color: (\n  500: rgba(45, 211, 111, 1),\n  300: rgba(66, 215, 125, 1),\n  700: rgba(40, 186, 98, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$dark-color: (\n  500: rgba(34, 36, 40, 1),\n  300: rgba(60, 60, 59, 1),\n  700: rgba(87, 87, 86, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$medium-color: (\n  500: rgba(112, 111, 111, 1),\n  300: rgba(135, 135, 135, 1),\n  700: rgba(189, 188, 188, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$light-color: (\n  500: rgba(227, 227, 227, 1),\n  300: rgba(245, 246, 249, 1),\n  700: rgba(189, 188, 188, 1),\n  contrast: (500: black,\n    300: black,\n    700: black,\n  ),\n);","@import \"variables\";\n\nbody {\n  font-family: \"Barlow\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 19px;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 600;\n}\n\nh1 {\n  font-size: 64px;\n  line-height: 78px;\n}\n\nh2 {\n  font-size: 56px;\n  line-height: 68px;\n}\n\nh3 {\n  font-size: 48px;\n  line-height: 58px;\n}\n\nh4 {\n  font-size: 40px;\n  line-height: 48px;\n}\n\nh5 {\n  font-size: 32px;\n  line-height: 39px;\n}\n\nh6 {\n  font-size: 24px;\n  line-height: 29px;\n}\n\na {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 19px;\n  color: map-get($primary-color, 500);\n  cursor: pointer;\n  text-decoration: underline;\n}\n\ncaption {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14px;\n}\n\nth {\n  font-weight: 700;\n  cursor: pointer;\n}\n","$spacing-sizes: (\n  0: 0px,\n  1: 8px,\n  2: 16px,\n  3: 24px,\n  4: 32px,\n  5: 40px,\n  6: 48px,\n  7: 56px,\n  8: 64px,\n  9: 72px,\n  10: 80px,\n);\n\n@each $key, $size in $spacing-sizes {\n  .p-#{$key} {\n    padding: #{$size};\n  }\n  .pt-#{$key} {\n    padding-top: #{$size};\n  }\n  .pr-#{$key} {\n    padding-right: #{$size};\n  }\n  .pb-#{$key} {\n    padding-bottom: #{$size};\n  }\n  .pl-#{$key} {\n    padding-left: #{$size};\n  }\n  .px-#{$key} {\n    padding-left: #{$size};\n    padding-right: #{$size};\n  }\n  .py-#{$key} {\n    padding-top: #{$size};\n    padding-bottom: #{$size};\n  }\n\n  .m-#{$key} {\n    margin: #{$size};\n  }\n  .mt-#{$key} {\n    margin-top: #{$size};\n  }\n  .mr-#{$key} {\n    margin-right: #{$size};\n  }\n  .mb-#{$key} {\n    margin-bottom: #{$size};\n  }\n  .ml-#{$key} {\n    margin-left: #{$size};\n  }\n  .mx-#{$key} {\n    margin-left: #{$size};\n    margin-right: #{$size};\n  }\n  .my-#{$key} {\n    margin-top: #{$size};\n    margin-bottom: #{$size};\n  }\n}\n","@use \"@angular/material\" as mat;\n@include mat.core();\n@import url(\"https://fonts.googleapis.com/icon?family=Material+Icons\");\n@import \"theme/typography.scss\";\n@import \"theme/variables.scss\";\n@import \"theme/spacing\";\n@import url(\"https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap\");\nhtml {\n  --mdc-outlined-text-field-focus-outline-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n  --mdc-outlined-text-field-focus-label-text-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n\n  --mat-option-selected-state-label-text-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n\n  --mat-datepicker-toggle-active-state-icon-color: rgba(\n    174,\n    15,\n    10,\n    1\n  ) !important;\n\n  --mdc-filled-text-field-focus-active-indicator-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n\n  --mat-sidenav-content-background-color: white !important;\n}\n\n/* You can add global styles to this file, and also import other style files */\n/* Angular 15 adds grey background on mat form components */\n/* below removes that background color */\n/* Manipulate initial background color*/\n.mdc-text-field--filled:not(.mdc-text-field--disabled) {\n  background-color: transparent !important;\n}\n\n/*Manipulate background color on hover and focus*/\n.mat-mdc-form-field-focus-overlay {\n  background-color: transparent !important;\n}\n\n.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {\n  width: 0px;\n  padding-left: 6px;\n  padding-right: 6px;\n\n  span {\n    display: none;\n  }\n}\n\n/* Pagination menu */\n.g-bubble-container {\n  display: flex;\n  gap: 4px;\n  margin-left: 8px;\n}\n\n.g-bubble {\n  background-color: map-get($light-color, 300);\n  border-radius: 4px;\n  width: 34px;\n  height: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: map-get($dark-color, 500) !important;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: 0.3s;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0.5px;\n  text-align: center;\n  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12),\n    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);\n}\n\n.g-bubble:hover {\n  background-color: map-get($light-color, 700);\n  color: map-get($light-color, 300);\n}\n\n.g-bubble__active {\n  background-color: map-get($primary-color, 300);\n  color: map-get($light-color, 500) !important;\n  box-shadow: 0px 5px 14px 0px rgba(0, 0, 0, 0.12),\n    0px 9px 10px 0px rgba(0, 0, 0, 0.14), 0px 5px 5px 0px rgba(0, 0, 0, 0.2);\n}\n\nmat-paginator {\n  background: transparent !important;\n}\n\n.mat-mdc-paginator-range-actions {\n  margin-right: 12px !important;\n}\n\n.mat-mdc-paginator-container {\n  justify-content: center !important;\n}\n\n.mat-mdc-paginator-navigation-next,\n.mat-mdc-paginator-navigation-previous {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  color: map-get($dark-color, 500) !important;\n  padding: 0 !important;\n  border-radius: 4px !important;\n  width: 34px !important;\n  height: 34px !important;\n  background-color: map-get($light-color, 300) !important;\n  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12),\n    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);\n}\n\n/* End of pagination menu */\n\nbody {\n  margin: 0;\n}\n\n.snackbar {\n  width: 50vw;\n  margin: 10px 0px !important;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.snackbar-custom {\n  width: 50vw;\n  margin-top: 75px !important;\n}\n\n.snacbar-warning {\n  width: 50vw;\n  margin: 10px 0px;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n    border: 1px solid #e0ac08;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.snacbar-sucess {\n  width: 50vw;\n  margin: 10px 0px;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n    border: 1px solid green;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.snacbar-error {\n  width: 50vw;\n  margin: 10px 0px;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n    border: 1px solid red;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.flex {\n  display: flex;\n}\n\n.mat-mdc-menu-panel {\n  overflow: hidden !important;\n\n  .mat-mdc-menu-content {\n    .menu-header {\n      font-size: 12px;\n      padding: 1rem;\n      padding-bottom: 0.25rem;\n    }\n\n    .mat-mdc-menu-item {\n      margin-left: 1rem;\n      padding-left: 0;\n    }\n\n    .mat-mdc-menu-item:first-of-type {\n      margin-top: 0.75rem;\n    }\n\n    .mat-mdc-menu-item:not(:last-child) {\n      border-bottom: 1px solid map-get($light-color, 700);\n    }\n  }\n}\n\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 3000;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.sort-icon-container {\n  display: inline-flex;\n  align-items: center;\n\n  mat-icon {\n    height: 1rem;\n    width: 1rem;\n  }\n}\napp-edit-contract{\n  .btn-primary.mat-mdc-unelevated-button.mat-unthemed {\n    @media (max-width: 767px) {\n      margin-top: 15px;\n      margin-right: 0 !important;\n      width: 40% !important;\n      height: 45px;\n    }\n  }\n}\n.btn-primary.mat-mdc-unelevated-button.mat-unthemed {\n  background: map-get($primary-color, 500);\n  color: white;\n  width: 14rem;\n  border-radius: 10px;\n  padding: 0.75rem 0;\n  border: none;\n  font-weight: bold;\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    margin-right: 0 !important;\n    width: 40%;\n    height: 45px;\n  }\n\n  &[disabled] {\n    background: map-get($medium-color, 700);\n  }\n}\n\n.btn-secondary.mat-mdc-unelevated-button.mat-unthemed {\n  background: white;\n  color: map-get($primary-color, 500);\n  width: 14rem;\n  border-radius: 10px;\n  padding: 0.75rem 0;\n  border: 2px solid map-get($primary-color, 500);\n  font-weight: bold;\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    width: 100%;\n    height: 45px;\n  }\n\n  &[disabled] {\n    background: map-get($medium-color, 700);\n  }\n}\n\n.btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {\n  background: map-get($medium-color, 700);\n  color: white;\n  width: 14rem;\n  border-radius: 10px;\n  padding: 0.75rem 0;\n  border: none;\n  font-weight: bold;\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    width: 100%;\n    height: 45px;\n  }\n}\n\n/* \n  IONIC components\n*/\nion-item.no-padding {\n  --padding-end: 0;\n  --padding-start: 0;\n}\n\nion-item.no-padding-full {\n  --padding-end: 0;\n  --padding-start: 0;\n  --inner-padding-end: 0;\n  --inner-padding-start: 0;\n}\nion-checkbox {\n  --checkbox-background-checked: rgba(174, 15, 10, 1);\n  --border-color-checked: rgba(174, 15, 10, 1);\n}\n\nion-input.custom-input {\n  --border-color: rgba(135, 135, 135, 1);\n  --padding-top: 5px;\n  --highlight-color: rgba(135, 135, 135, 1);\n}\nion-input.custom-input-user {\n  --border-color: #EFEFEF;\n  --padding-top: 5px;\n  --highlight-color: rgba(135, 135, 135, 1);\n}\nion-input.width-full {\n  --border-color: #EFEFEF !important;\n  --padding-top: 5px;\n  --highlight-color: rgb(37, 19, 19);\n}\n.filter-panel {\n  max-width: 100vw !important;\n}\n.date-select-modal-filter {\n  .mdc-text-field {\n    height: 35px;\n  }\n  .mat-mdc-form-field-infix {\n    height: 35px;\n    min-height: 35px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-top: 0px !important;\n    padding-bottom: 0px !important;\n  }\n  .select-year {\n    .mat-mdc-text-field-wrapper {\n      background-color: #f4f4f4;\n      border: 1px solid rgb(189, 188, 188);\n    }\n  }\n\n  .mdc-notched-outline__leading {\n    border: none !important;\n  }\n  .mdc-notched-outline__notch {\n    border: none !important;\n  }\n  .mdc-notched-outline__trailing {\n    border: none !important;\n  }\n}\n\n@media (min-width: 1025px) {\n  .filter-panel {\n    max-height: 33rem !important;\n    min-width: 60vw;\n  }\n\n  .anotation-panel {\n    max-width: 30rem !important;\n    max-height: 30rem !important;\n    min-width: 50vw;\n  }\n\n  .historic-panel {\n    min-width: 49.5rem;\n    min-height: 35.625rem;\n    min-width: 50vw;\n  }\n  .segments-panel {\n    width: 72vw;\n    min-width: 760px;\n    max-width: 1100px !important;\n    max-height: 90vh !important;\n  }\n  .new-highway-modal-panel {\n    min-width: 49.5rem;\n    min-height: 23.625rem;\n    min-width: 50vw;\n  }\n}\n\n@media (max-width: 1024px) {\n  .btn-actions {\n    margin-right: 15px;\n  }\n  .filter-panel {\n    min-height: 30rem;\n    max-width: 100vw !important;\n    min-width: 90vw;\n  }\n\n  .historic-panel {\n    max-width: 49.5rem;\n    min-width: 90vw !important;\n  }\n  .segments-panel {\n    max-width: 90vw !important;\n    min-width: 90vw !important;\n    max-height: 90vh !important;\n  }\n    .new-highway-modal-panel {\n  max-width: 49.5rem;\n    min-width: 90vw !important;\n  }\n}\n\n@media (max-width: 1024px) {\n  .anotation-panel {\n    width: 90%;\n  }\n}\n\n.mdc-text-field--filled:not(.mdc-text-field--disabled) {\n  background-color: transparent !important;\n}\n\n@media (max-width: 1024px) {\n  .mat-mdc-form-field-label {\n    font-size: 0.8rem;\n    /* Tamanho de fonte para dispositivos móveis */\n  }\n}\n\n.button_cad {\n  background-color: map-get($primary-color, 500);\n  padding: 0.5rem 2rem;\n  border-radius: 0.5rem;\n  color: #fff;\n  font-style: none;\n  text-decoration: none;\n\n  mat-icon {\n    color: #fff !important;\n  }\n}\n\n::ng-deep.mat-mdc-card-header-text {\n  display: none !important;\n}\n.input-error {\n  border: 1px solid red; /* Ajuste o estilo conforme necessário */\n}\n.card-mobile {\n  min-height: 10rem;\n  margin: 1rem auto;\n  border: 1px solid #cdcdcd;\n\n  .mat-mdc-card-header {\n    width: 90%;\n    display: flex;\n    margin: auto;\n    // align-items: center;\n    justify-content: space-between;\n    padding: 0rem;\n\n    p {\n      font-weight: bolder;\n      font-size: 1.2rem;\n      text-transform: uppercase;\n    }\n\n    span,\n    .subtitle {\n      font-size: 1rem;\n      font-weight: normal;\n      color: #cdcdcd;\n    }\n    @media (max-width: 1024px) {\n      width: 100%;\n      margin: 0 16px;\n    }\n  }\n\n  .mat-mdc-card-footer {\n    margin: 1rem 0rem;\n    border-top: 1px solid black;\n    display: flex;\n    align-items: center;\n\n    button {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n    }\n  }\n\n  .extension {\n    font-weight: bold;\n    color: map-get($primary-color, 500);\n  }\n  .formatAnotation {\n    @media (max-width: 1024px) {\n      padding: 0 16px;\n    }\n  }\n\n  .content-card {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .content-status {\n    width: 40%;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n\n    p {\n      font-weight: bold;\n    }\n  }\n}\n\n.card-mobile-empty {\n  border: 1px solid #cdcdcd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nion-button.more-filters-btn {\n  --background: rgba(174, 15, 10, 1);\n  --color: white;\n  --border-radius: 10px;\n  width: 100%;\n  max-width: 15rem;\n  text-transform: capitalize;\n  font-size: 0.9rem;\n  height: 100%;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n}\n\nion-item.fast-filters {\n  padding: 0.25rem 0rem;\n}\n\nion-chip.fast-filter-active-primary {\n  background-color: map-get($success-color, 700);\n  color: white;\n}\n\nion-chip.fast-filter-active-secondary {\n  background-color: map-get($danger-color, 500);\n  color: white;\n}\nion-chip.fast-filter-active-primary-contract {\n\n  color: #AE0F0A;\n  border: 1px solid #AE0F0A;\n  background: #E4ADB5;\n\n}\n\nion-chip.fast-filter-active-secondary-contract {\n  color: #AE0F0A;\n  border: 1px solid #AE0F0A;\n  background: #E4ADB5;\n}\n.more-filters-btn-row {\n  justify-content: center;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n\n  button {\n    margin: 5px;\n  }\n\n  @media (max-width: 767px) {\n    button {\n      margin: 5px 0;\n    }\n  }\n}\n\n.status-container {\n  display: flex;\n  align-items: center;\n\n  .mat-icon {\n    width: 1rem;\n  }\n\n  .status-icon {\n    font-size: 8px;\n    align-content: center;\n    text-align: center;\n  }\n\n  .active {\n    color: map-get($success-color, 700);\n  }\n\n  .inactive {\n    color: map-get($danger-color, 500);\n  }\n}\n\nion-textarea,\nion-input {\n  --border-color: rgba(87, 87, 86, 1);\n  --padding-top: 5px !important;\n  --highlight-color: rgba(135, 135, 135, 1);\n  --highlight-color-focused: rgba(135, 135, 135, 1) !important;\n  --highlight-color-valid: rgba(135, 135, 135, 1) !important;\n  --highlight-color-invalid: rgba(174, 15, 10, 1) !important;\n}\n\nion-alert.custom-alert {\n  --backdrop-opacity: 0.7;\n}\n\nion-list.filtered-list {\n  display: flex;\n  flex-wrap: wrap;\n\n  span {\n    padding: 0.75rem 0;\n    margin: 0 0.75rem;\n    border-bottom: 1px solid map-get($light-color, 700);\n    width: 100%;\n  }\n}\n\nion-item.no-padding {\n  --padding-end: 0;\n  --padding-start: 0;\n}\n\n// Toast\nion-toast.snackbar-toast {\n  --box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);\n  --width: fit-content;\n  --border-radius: 0.75rem;\n  --white-space: pre-line;\n}\n\nion-toast.snackbar-toast {\n  &::part(container) {\n    background: #fff;\n    color: rgba(34, 36, 40, 1);\n    width: fit-content;\n    border-radius: 0.75rem;\n  }\n}\n\nion-toast.snackbar-toast.toast-success {\n  &::part(container) {\n    border: 1px solid rgba(45, 211, 111, 1);\n  }\n\n  &::part(icon) {\n    color: rgba(45, 211, 111, 1);\n    font-size: 1.25rem;\n  }\n}\n\nion-toast.snackbar-toast.toast-error {\n  &::part(container) {\n    border: 1px solid rgba(235, 68, 90, 1);\n  }\n\n  &::part(icon) {\n    color: rgba(235, 68, 90, 1);\n    font-size: 1.25rem;\n  }\n}\n\nion-toast.snackbar-toast.toast-right {\n  --start: right;\n  --box-shadow: none;\n  --background: none;\n\n  &::part(container) {\n    transform: translateY(72px) !important;\n    box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);\n  }\n}\n\n::ng-deep.mat-tab-label {\n  min-width: 25px !important;\n  padding: 5px;\n  background-color: transparent;\n  color: red !important;\n  font-weight: 700;\n}\n\n/* Styles for the active tab label */\n::ng-deep.mat-tab-label.mat-tab-label-active {\n  min-width: 25px !important;\n  padding: 5px;\n  background-color: transparent;\n  color: red !important;\n  font-weight: 700;\n}\n\n::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab\n  .mdc-tab-indicator__content--underline {\n  border-color: #2b2b2b;\n}\n\n// .mat-mdc-tab .mdc-tab-indicator__content--underline {\n//   border-color: #2b2b2b;\n// }\n\n::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active\n  .mdc-tab__text-label {\n  color: #2b2b2b;\n}\n\n.mat-mdc-paginator-navigation-next, .mat-mdc-paginator-navigation-previous {\n      box-shadow: none !important;\n}\n.g-bubble {\n  box-shadow: none !important;\n}\napp-modal-historic-segment {\n  display: block;\n  width: 100%;\n  height: 45em;\n}\n\n.column-flex {\n  display: flex;\n  flex-flow: column;\n}\n\n.master-icon {\n  background-color: map-get($warning-color, 300);\n  color: map-get($dark-color, 500);\n  border-radius: 10px;\n  align-self: flex-start;\n  font-size: 10px;\n  padding: 0px 9px;\n  margin: 6px 0;\n  line-height: 17px;\n  font-weight: 600;\n\n  &.center-horizontal {\n    place-self: center;\n  }\n}\n\nion-popover {\n  --min-width: 375px;\n  --max-width: 500px;\n}\n.custom-tooltip-menu {\n  padding: 8px;\n  \n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n\n  .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {\n    background: none;\n  }\n  .mdc-evolution-chip__text-label {\n    color: #c00;\n  }\n}\n\n.custom-tooltip-menu .filter-title {\n  font-size: 12px;\n  font-weight: bold;\n  color: #333;\n  display: block;\n  margin-bottom: 4px;\n  border-bottom: 1px solid grey;\n}\n\n.custom-tooltip-menu .tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.custom-tooltip-menu mat-chip {\n  border: 1px solid #c00;\n  height: 20px;\n}\n\n.custom-tooltip-menu mat-chip mat-icon {\n  color: #c00 !important;\n  cursor: pointer;\n  font-size: 14px !important;\n  opacity: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-right: 0px !important;\n}\n.custom-tooltip-menu mat-chip .mdc-evolution-chip__text-label {\n  color: #c00 !important;\n  cursor: pointer;\n  font-size: 12px !important;\n  opacity: 1;\n}\n::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline  {\n  border: 1px solid #c00 !important;\n}\n::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {\n  color: #c00 !important;\n}\nion-toggle {\n  --handle-background-checked: rgba(174, 15, 10, 1);\n  --track-background-checked: rgba(174, 15, 10, 0.38);\n}\napp-list-contracts {\n  thead{\n    background: #F4F4F4 !important;\n  }\n}\napp-table-default{\n  thead{\n    background: #F4F4F4 !important;\n  }\n}\n.mat-expansion-panel-body{\n  padding: 0px !important;\n}\n.mat-mdc-paginator-range-actions {\n \n  overflow-wrap: anywhere !important;\n  flex-grow: 1;\n  justify-content: center !important;\n  position: relative !important;\n}\n.mat-mdc-paginator-container:has(.mat-mdc-paginator-page-size) .mat-mdc-paginator-range-actions .mat-mdc-paginator-range-label {\n  position: absolute !important;\n  left: 0 !important;\n}\n.mat-mdc-tab{\n  background-color: #F4F4F4 !important;\n}\n.mdc-tab--active{\n  background-color: white !important;\n}\n#paginator{\n  @media(max-width: 1025px){\n    width: 100%;\n  }\n\n}\nion-icon.search-icon-absolute {\n  position: absolute;\n  left: 16px;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  z-index: 3;\n}\n\nion-input.search-input {\n  label.input-wrapper {\n    --padding-start: 55px;\n  }\n\n  &.has-focus,\n  &.has-value {\n    .input-wrapper {\n      .label-text-wrapper {\n      }\n    }\n  }\n}\n.mat-mdc-icon-button[disabled] {\n    cursor: default;\n        pointer-events: auto;\n    opacity: .38;\n}\n.mat-mdc-unelevated-button[disabled] {\n    cursor: default;\n      pointer-events: auto;\n    opacity: .38;\n}\n\n.item-inner{\n  padding-right: 0 !important;\n}\n\n.mat-mdc-paginator-page-size-label {\n  @media (max-width: 496px) {\n    display: none !important;\n  }\n}\n.comentarios .mdc-text-field--outlined {\n  --mdc-outlined-text-field-outline-width: 1px;\n  --mdc-outlined-text-field-outline-color: #EFEFEF; /* Borda normal */\n  --mdc-outlined-text-field-focus-outline-color: #EFEFEF; /* Borda ao focar */\n  --mdc-outlined-text-field-container-shape: 4px;\n}\n// Gaps gerais\n.g-0 { gap: 0 !important; }\n.g-1 { gap: 0.25rem !important; }\n.g-2 { gap: 0.5rem !important; }\n.g-3 { gap: 1rem !important; }\n.g-4 { gap: 1.5rem !important; }\n.g-5 { gap: 3rem !important; }\n\n// Gaps horizontais\n.gx-0 { column-gap: 0 !important; }\n.gx-1 { column-gap: 0.25rem !important; }\n.gx-2 { column-gap: 0.5rem !important; }\n.gx-3 { column-gap: 1rem !important; }\n.gx-4 { column-gap: 1.5rem !important; }\n.gx-5 { column-gap: 3rem !important; }\n\n// Gaps verticais\n.gy-0 { row-gap: 0 !important; }\n.gy-1 { row-gap: 0.25rem !important; }\n.gy-2 { row-gap: 0.5rem !important; }\n.gy-3 { row-gap: 1rem !important; }\n.gy-4 { row-gap: 1.5rem !important; }\n.gy-5 { row-gap: 3rem !important; }\n.col {\n  flex: 1 0 0%;\n  max-width: 100%;\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n}\n\n.col-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n.col-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n.col-3 { flex: 0 0 23%; max-width: 23%; }\n.col-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n.col-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n.col-6 { flex: 0 0 48%; max-width: 48%; }\n.col-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n.col-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n.col-9 { flex: 0 0 73%; max-width: 73%; }\n.col-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n.col-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n.col-12 { flex: 0 0 98%; max-width: 98%; }\n\n/* Colunas responsivas */\n@media (min-width: 576px) { /* sm */\n  .col-sm-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-sm-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-sm-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-sm-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-sm-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-sm-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-sm-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-sm-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-sm-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-sm-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-sm-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-sm-12 { flex: 0 0 98%; max-width: 98%; }\n}\n\n@media (min-width: 768px) { /* md */\n  .col-md-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-md-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-md-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-md-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-md-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-md-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-md-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-md-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-md-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-md-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-md-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-md-12 { flex: 0 0 100%; max-width: 100%; }\n}\n\n@media (min-width: 992px) { /* lg */\n  .col-lg-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-lg-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-lg-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-lg-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-lg-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-lg-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-lg-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-lg-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-lg-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-lg-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-lg-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-lg-12 { flex: 0 0 98%; max-width: 98%; }\n}\n\n@media (min-width: 1200px) { /* xl */\n  .col-xl-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-xl-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-xl-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-xl-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-xl-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-xl-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-xl-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-xl-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-xl-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-xl-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-xl-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-xl-12 { flex: 0 0 98%; max-width: 98%; }\n}\n\n@media (min-width: 1400px) { /* xxl */\n  .col-xxl-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-xxl-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-xxl-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-xxl-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-xxl-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-xxl-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-xxl-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-xxl-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-xxl-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-xxl-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-xxl-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-xxl-12 { flex: 0 0 98%; max-width: 98%; }\n}\n.ampliacao-panel{\n  max-width: 60vw !important;\n}\n.popover-content{\n  max-height: 150px;\n}\napp-form-projetos thead tr th{\n    font-family: \"Barlow\", sans-serif !important;\n    font-weight: 500 !important;\n    font-size: 18px !important;\n    line-height: 100% !important;\n  \n}\napp-form-projetos .mat-mdc-header-cell{\n    border: none !important;\n  \n}\napp-form-projetos .mat-mdc-form-field-subscript-wrapper {\n    display: none;\n}\n\n.mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background\n {\n    border-color: #AE0F0A !important;\n    background-color: #AE0F0A !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
